import React, { useEffect, useRef, useState } from 'react'

import { add, addDays, format, isAfter, isBefore, isToday, isValid, parse, setHours, setMinutes } from 'date-fns';
import RecommendeCard from './component/RecommendeCard';
import popcornImg from "../../assets/food/popcorn2.svg";
import vegIcon from "../../assets/food/veg.svg";
import traDicPVR from '../../assets/food/tras-dis.svg'
import traDicINOX from '../../assets/food/checkoutcoupen.svg'
import rightArr from '../../assets/food/bigright-arrow.svg'
import closeIcon from "../../assets/food/close.svg";
import dassadLine from "../../assets/food/dass-line.svg";
import rightArrow from "../../assets/food/rightArr.svg";
import miv_inox from "../../assets/default-images/vertical-poster-inox.svg";
import miv_pvr from "../../assets/default-images/vertical-poster-pvr.svg";
import noSack from "../../assets/food/no-snack.svg";
import priceArrow from "../../assets/food/price-arrow.svg";
import cartIcon from "../../assets/food/cartIcon.svg";
import { json, Link, useLocation, useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import FbHeader from './component/FbHeader';
// import UpgradeCart from './component/UpgradeCart';
import { Modal } from 'react-bootstrap';
import Seat from '../../assets/food/aircraft.svg'
import SeatInox from '../../assets/food/aircraftinox.svg'
import scrollIcon from "../../assets/food/scrollarrow.svg";
import seactNotFound from '../../assets/food/seatnotfound.svg'
import expandIcon from "../../assets/food/expandSmall.svg";
import checkPVR from '../../assets/food/check.svg'
import checkINOX from '../../assets/food/checkInox.svg'
import noImg from "../../assets/food/noimage250.png";
import nonvegIcon from "../../assets/food/nonveg.svg";
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import MobilePayment from '../mobile-views/mobile-payment/MobilePayment';
import leftLinePVR from "../../assets/food/leftLine.svg";
import rightLinePVR from "../../assets/food/rightLine.svg";
import rightLineINOX from "../../assets/food/leftLine-INOX.svg";
import leftLineINOX from "../../assets/food/rightLine-INOX.svg";
import offerSuccess from "../../assets/food/offer_success.svg";
import offerSuccessInox from "../../assets/food/offer_success_inox.svg";
import { setGrandTotalamount } from 'src/redux/actions/gradTotalAction';
import * as appConstants from "../../constants/index";
import SweetAlert from 'react-bootstrap-sweetalert';
import SweetAlertUtility from './component/SweetAlertUtility';
import FnbCheckoutSkeleton from 'src/skeletons/FnbCheckoutSkeleton';
import Navbar from '../common/navbar/Navbar';
import { getResponsiveClasses } from './component/ResponsiveClasses';
import { setLoginViewMode } from 'src/redux/actions/loginViewAction';
import { Dialog } from 'primereact/dialog';
import Login from '../common/login/Login';
import Footer from '../common/footer/Footer';
import AddButton from './component/AddButton';
import UpgradeCart from './component/UpgradeCart';
import "swiper/css";
import { IsEvent } from 'src/global-functions/globalFunctions';
import ExtendTime from '../common/extend-time/ExtendTime';
import BookingSummarySkeleton from 'src/skeletons/BookingSummarySkeleton';
import { FaRupeeSign } from 'react-icons/fa';
import SeatLayoutBreadBrumb from '../common/app-breadcrumb/SeatLayoutBreadBrumb';
import ApplyOffers from './component/ApplyOffers';

const Checkout = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	// const [addedItems, setAddedItems] = useState({});
	// const [selected, setSelected] = useState(() => {
	// 	return localStorage.getItem("selectRadioClick") || undefined;
	// });
	const [selected, setSelected] = useState('');
	const [loading, setLoading] = useState(false);
	const [loadingSeat, setLoadingSeat] = useState(false);
	const [paymentLoading, setPaymentLoading] = useState(false);
	const [payDetailLoading, setPayDetailLoading] = useState(false);
	const [deliverySeat, setDeliverySeat] = useState();
	const [showYourSeatModal, setShowYourSeatModal] = useState(false);
	const [showYourSeatManual, setShowYourSeatManual] = useState(false);
	const [showUpgradeModal, setShowUpgradeModal] = useState(false);
	const [showOffer, setShowOffer] = useState(false);
	const [applyFailed, setApplyFailed] = useState(false);
	const [expand, setExpand] = useState(false);
	const [removeApplied, setRemoveApplied] = useState(false);
	const [selectedSeat, setSelectedSeat] = useState(null);
	// const [confirmedSeats, setConfirmedSeats] = useState([]);
	const [apiCalled, setApiCalled] = useState(false);
	const [addscreenId, setAddscreenId] = useState(0);
	const [seatDetailData, setSeatDetailData] = useState(null);
	const [errMsg, setErrMsg] = useState(false);
	const [userSelectedFood, setUserSelectedFood] = useState();
	// const [seatDetailsState, setSeatDetailsState] = useState(location?.state?.seatdetails || null);
	const [deliveryConfirmSeat, setDeliveryConfirmSeat] = useState(null);
	const [fnbPaymentDetailsRes, setFnbPaymentDetailsAPIRes] = useState([]);
	const [showSeatInfo, setShowSeatInfo] = useState(true);
	const [alertDetails, setAlertDetails] = useState({ show: false, type: '', title: '', message: '' });
	const [finalTicket, setFinalTicket] = useState(null);
	const [isBadTransaction, setIsBadTransaction] = useState(false);
	const [showAlert, setShowAlert] = useState(false);
	const [errorMsg, setErrorMsg] = useState(null);
	const [formattedShowTime, setFormattedShowTime] = useState(null);
	const [formattedEndTime, setFormattedEndTime] = useState(null);
	const [upgradeData, setUpgradeData] = useState([]);
	const [selectedItem, setSelectedItem] = useState(null);
	const [upgradeItem, setUpgradeItem] = useState(null);
	const [activeIndex, setActiveIndex] = useState(0);
	const [showConvFee, setShowConvFee] = useState(false);
	const [prepTime, setPrepTime] = useState(0);
	const [appliedOffer, setAppliedOffer] = useState(null);
	const [nearestOffer, setNearestOffer] = useState(null);

	const isMobile = window.matchMedia("(max-width: 575px)").matches;

	const appliedVocher = JSON.parse(localStorage.getItem("AppliedOfferData"));
	const selectedTheater = JSON.parse(localStorage.getItem("selectedTheater"));
	const seatdetails = JSON.parse(localStorage.getItem("seatdetails"));
	const currExperience = localStorage.getItem("currExperience") || "NORMAL";
	const addFoodItems = JSON.parse(localStorage.getItem("addFoodItems")) || null;
	const screenType = localStorage.getItem("Experience") || "";
	const cinemaname = localStorage.getItem("cinema_name");
	// const whereIsUser = localStorage.getItem("TransactionType");	
	const discAmt = parseFloat(appliedVocher?.resOffer?.output?.di);
	const finalAmount = parseFloat(appliedVocher?.resOffer?.output?.dp);

	const theme = localStorage.getItem("theme");
	const userInfoData = JSON.parse(sessionStorage.getItem("loginInfo")) || "";
	const authToken = "Bearer " + (sessionStorage.getItem("token") || " ");
	const theatreId = localStorage.getItem("theaterId");
	const city = localStorage.getItem("city");
	const bookType = localStorage.getItem("booking_type") || "FOOD";
	const transId = localStorage.getItem("transid") || 0;
	const bookingId = localStorage.getItem("bookingid") || "";
	const loginInfo = JSON.parse(sessionStorage.getItem("loginInfo") || "null");
	const selectedMovie = JSON.parse(localStorage.getItem("selectedMovie"));
	const FoodPickupDateTime = localStorage.getItem("FoodPickupDateTime")
	const TransactionType = localStorage.getItem("TransactionType");
	const fnb_qr = localStorage.getItem("fnb_qr");
	const fnbCoupen = JSON.parse(localStorage.getItem("fnbCoupen"));
	const fnbVouchers = JSON.parse(localStorage.getItem("fnbVouchers"));
	const clu = JSON.parse(localStorage.getItem("clu"));
	const cua = JSON.parse(localStorage.getItem("cua"));
	const seatPrice = Number(localStorage.getItem("seatPrice")) || 0;
	// const storedDataString = localStorage.getItem("getAllFnbData");
	const storedConfirmSeat = localStorage.getItem("DeliverytoSeatData");
	const seatsArray = seatDetailData?.[0]?.seats ? seatDetailData?.[0]?.seats.split(",") : [];
	localStorage.removeItem('targetTime');

	const [addedItems, setAddedItems] = useState([]);
	const isInitialLoad = useRef(true);
	const scrollRepeatAgainRef = useRef(null);
	const cartItemIds = useRef([]);
	const scrollUpgradeRef = useRef(null);
	const loginVewMode = useSelector((state) => state.loginViewMode.value);
	const HaptikBookingid = localStorage.getItem("haptikbookingid");
	const seatCount = localStorage.getItem("seatCount") || 10;


	// Extract year, month, and day
	const todayDate = new Date(Date.now() + (prepTime ? prepTime * 60 * 1000 : 0));
	const year = todayDate.getFullYear();
	const month = String(todayDate.getMonth() + 1).padStart(2, "0"); // Months are zero-based, so add 1
	const day = String(todayDate.getDate()).padStart(2, "0");
	const formattedDate = `${year}-${month}-${day}`;

	// Format the time as "hh:mm:ss"
	const currentTime = new Date(Date.now() + (prepTime ? prepTime * 60 * 1000 : 0));
	const hours = String(currentTime.getHours()).padStart(2, "0");
	const minutes = String(currentTime.getMinutes()).padStart(2, "0");
	const seconds = String(currentTime.getSeconds()).padStart(2, "0");
	const formattedTime = `${hours}:${minutes}:00`;

	const OnlyFBDate = FoodPickupDateTime ? bookType === "BOOKING" ? format(FoodPickupDateTime, "dd MMM yy, hh:mm a").split(",") : FoodPickupDateTime.split(",") : null;

	const isFutureDate = FoodPickupDateTime && new Date(FoodPickupDateTime) > new Date();
	const isPastDate = FoodPickupDateTime && new Date(FoodPickupDateTime) < new Date();
	const isCurrentDate = FoodPickupDateTime && new Date(FoodPickupDateTime).toDateString() === new Date().toDateString();
	const FinalBookingDate = OnlyFBDate && isFutureDate ? format(parse(OnlyFBDate[0], "dd MMM yy", new Date()), "yyyy-MM-dd") : formattedDate.toString();
	const FinalBookingTime = OnlyFBDate && isFutureDate ? format(parse(OnlyFBDate[1].trim(), "hh:mm a", new Date()), "HH:mm:ss") : formattedTime.toString();
	//Condition for 9am - 11pm
	let calculatedPickupTime = isFutureDate ? new Date(FoodPickupDateTime) : new Date(Date.now() + (prepTime ? prepTime * 60 * 1000 : 0));

	const selectedDate = new Date(calculatedPickupTime);
	const selected9AM = setMinutes(setHours(selectedDate, 0), 0);
	const selected11PM = setMinutes(setHours(selectedDate, 23), 59);
	const nextDay9AM = setMinutes(setHours(addDays(selectedDate, 1), 9), 0);
	const movieDatavalue = JSON.parse(localStorage.getItem("selectedMovie"));
	const [selectedOption, setSelectedOption] = useState("");
	const [screenName, setScreenName] = useState("");


	if (bookType !== "BOOKING") {
		if (isAfter(calculatedPickupTime, selected11PM)) {
			// Keep same time on same day, just add prep time
			calculatedPickupTime = new Date(Date.now() + (prepTime ? prepTime * 60 * 1000 : 0));
			// OLD CODE: calculatedPickupTime = nextDay9AM; // Move to 9 AM next day
		} else if (isBefore(calculatedPickupTime, selected9AM)) {
			calculatedPickupTime = selected9AM; // Move to 9 AM same day
		}
	}
	const PickupBookingDate = format(calculatedPickupTime, "dd-MMM-yyyy");
	const PickupBookingTime = format(calculatedPickupTime, "hh:mm a");
	const [isChecked, setIsChecked] = useState(false);

	const [isLeftArrowVisibleRepeat, setIsLeftArrowVisibleRepeat] =
		useState(false);
	const [isRightArrowVisibleRepeat, setIsRightArrowVisibleRepeat] =
		useState(true);

	// const PickupBookingDate = isFutureDate ? format(new Date(FoodPickupDateTime), "dd-MMM-yyyy") : prepTime ? format(new Date(Date.now() + (prepTime * 60 * 1000)), "dd-MMM-yyyy") : format(new Date(), "dd-MMM-yyyy");
	// const PickupBookingTime = isFutureDate ? format(new Date(FoodPickupDateTime), "hh:mm a") : prepTime ? format(new Date(Date.now() + (prepTime * 60 * 1000)), "hh:mm a") : format(new Date(), "hh:mm a");
	// localStorage.removeItem("cartItems");



	const { currentClasses, getWindowWidth } = getResponsiveClasses();

	const handleYourSeatModalShow = () => {
		setShowYourSeatModal(true)
	};

	const [isLeftArrowVisibleUpgrade, setIsLeftArrowVisibleUpgrade] = useState(false);
	const [isRightArrowVisibleUpgrade, setIsRightArrowVisibleUpgrade] = useState(true);

	const handleYourSeatManualShow = () => setShowYourSeatManual(true);

	const handleUpgradeModalShow = (item) => {
		setSelectedItem(item);
		setActiveIndex(0)
		const cartItems = JSON.parse(localStorage.getItem("cartItems") || "[]");
		const upgradeItem = cartItems.find((cartItem) => cartItem.ItemID === item.upgradeParentId);
		setUpgradeItem(upgradeItem || null);
		setShowUpgradeModal(true);
	};
	const handleYourSeatModalClose = () => {
		// if (!renderSeatInfo()) {
		// 	setSelected("radio2");
		// }
		setShowYourSeatModal(false);
	}
	const handleOfferClose = () => {
		setShowOffer(false);
		if (isMobile) {
			navigate(`/m.payment/${localStorage.getItem("cinema_name")}`);
		} else {
			navigate(`/payment/${localStorage.getItem("cinema_name")}`);
		}
	};
	const handleUpgradeModalClose = () => setShowUpgradeModal(false);

	const handleYourSeatManualClose = () => {
		// if (renderSeatInfo() === "") setSelected("radio2");
		setShowYourSeatManual(false);
	}
	const handleConfirm = (data) => {
		if (selectedSeat !== null && data.length > 0) {
			const confirmedSeatData = [{ filmId: data?.[0]?.filmId, audi: data?.[0]?.audi, seatno: selectedSeat }];
			localStorage.setItem("DeliverytoSeatData", JSON.stringify(confirmedSeatData));
		} else {
			setErrMsg(true);
			setShowYourSeatModal(true);
			return;
		}
		setShowYourSeatModal(false);
		localStorage.removeItem("seatdetails");
	};



	function getJourneyValue(add) {
		if (add?.familyBundle_data?.voucherDesc) return "buy_family_offer";
		if (add?.cvp_data) return "buy_cvp";
		if (add?.superTicketData) return "buy_super_ticket";
		if (add?.flexiTotalTicketPrice > 0) return "buy_flexi_ticket";
		return "";
	}


	let journeyvalue = "";
	if (localStorage.getItem("booking_type") === "BOOKING" && addedItems.foodType && addedItems.foodType !== "") {
		journeyvalue = "Movie_Food";
	} else if (localStorage.getItem("booking_type") === "BOOKING") {
		journeyvalue = "Movie";
	} else if (localStorage.getItem("bookingIdfood")) {
		journeyvalue = "Add_Food";
	} else if (addedItems.foodType === 1) {
		journeyvalue = "Only_Food";
	} else {
		journeyvalue = "";
	}

	localStorage.setItem("journey_value", journeyvalue);


	useEffect(() => {
		if (!loginInfo?.access?.token) {
			dispatch(setLoginViewMode({ value: true }));
		} else {
			hitGa("checkout_view");
		}
	}, [loginInfo?.access?.token]);

	const updateArrowVisibility = (container, type) => {
		const scrollLeft = container.scrollLeft;
		const maxScrollLeft = container.scrollWidth - container.clientWidth;

		const isLeftVisible = scrollLeft > 0;
		const isRightVisible = scrollLeft < maxScrollLeft;


		if (type === "scroll") {
			setIsLeftArrowVisibleUpgrade(isLeftVisible);
			setIsRightArrowVisibleUpgrade(isRightVisible);
		} else if (type === "repeat") {
			setIsLeftArrowVisibleRepeat(isLeftVisible);
			setIsRightArrowVisibleRepeat(isRightVisible);
		}
	};

	const handleUpgradeScroll = (type) => {
		const container = scrollUpgradeRef?.current;
		if (container) {
			container.scrollBy({
				left: type === "left" ? -560 : type === "right" ? 560 : 0,
				behavior: "smooth",
			});

			setTimeout(() => {
				updateArrowVisibility(container, "scroll");
			}, 500);
		}
	};

	const handleScrollRepeat = (type) => {
		const container = scrollRepeatAgainRef?.current;
		if (container) {
			container.scrollBy({
				left: type === "left" ? -560 : type === "right" ? 560 : 0,
				behavior: "smooth",
			});

			setTimeout(() => {
				updateArrowVisibility(container, "repeat");
			}, 500);
		}
	};

	const hitGa = (event) => {
		let dataLayer = window["dataLayer"] || [];
		dataLayer.push({
			event: event,
		});
	};


	const handleCheckboxChange = () => {
		setIsChecked(!isChecked);
	};

	const hitBeginCheckout = (
		event,
		currency,
		value,
		journey_type,
		discount,
		discount_type,
		movie_item_brand,
		movie_item_name,
		movie_item_id,
		movie_item_list_name,
		movie_item_list_id,
		movie_item_category,
		movie_item_category2,
		movie_item_category3,
		movie_item_category4,
		movie_item_category5,
		movie_price,
		movie_quantity,
		movie_item_variant,
		movie_location_id,
		food_item_brand,
		foodNames,
		foodIds,
		food_item_category,
		food_item_category2,
		food_item_category3,
		food_item_category4,
		food_item_category5,
		foodPrices,
		foodQuantities,
		food_location_id
	) => {
		const dataLayer = window.dataLayer || [];
		const items = [];

		// ✅ Only push movie item if not "Only_Food"
		if (journey_type.toLowerCase() !== "only_food" && journey_type.toLowerCase() !== "add_food" && localStorage.getItem("gatagbookingtype") !== "Food_QR") {
			items.push({
				item_brand: movie_item_brand,
				item_name: movie_item_name,
				item_id: movie_item_id,
				item_list_name: movie_item_list_name,
				item_list_id: movie_item_list_id,
				item_category: movie_item_category,
				item_category2: movie_item_category2,
				item_category3: movie_item_category3,
				item_category4: movie_item_category4,
				item_category5: movie_item_category5,
				price: Number(movie_price),
				quantity: Number(movie_quantity),
				item_variant: movie_item_variant,
				coupon: localStorage.getItem("discount_id"),
				location_id: localStorage.getItem("city") || ''
			});
		}

		// ✅ Add food items (always start from 0 index if only_food)
		const names = typeof foodNames === "string" ? foodNames.split(",") : [];
		const ids = typeof foodIds === "string" ? foodIds.split(",") : [];

		for (let i = 0; i < names.length; i++) {
			items.push({
				item_brand: food_item_brand,
				item_name: names[i],
				item_id: ids[i],
				item_category: food_item_category,
				item_category2: food_item_category2,
				item_category3: food_item_category3,
				item_category4: food_item_category4,
				item_category5: food_item_category5,
				price: Array.isArray(foodPrices) ? Number(foodPrices[i]) : 0,
				quantity: Array.isArray(foodQuantities) ? Number(foodQuantities[i]) : 1,
				coupon: localStorage.getItem("discount_id"),
				location_id: food_location_id
			});
		}

		// ✅ Push clean array to dataLayer
		dataLayer.push({
			event,
			ecommerce: {
				currency,
				value,
				journey_type,
				discount,
				discount_type,
				items
			}
		});
	};

	useEffect(() => {
		const savedCartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
		if (Array.isArray(savedCartItems) && savedCartItems.length > 0) {
			setAddedItems(savedCartItems);
		} else {
			setAddedItems([]);
		}
	}, []);

	useEffect(() => {
		if (isInitialLoad.current) {
			isInitialLoad.current = false;
			return;
		}

		cartItemIds.current = addedItems.map((item) => item.ItemID);
		const combinedUpgrade = addedItems.flatMap((item) => item.upgradeItems || []);
		const hasUpgradeItems = addedItems.some((item) => Array.isArray(item.upgradeItems) && item.upgradeItems.length > 0);
		setUpgradeData(hasUpgradeItems ? combinedUpgrade : []);
		localStorage.setItem("cartItems", JSON.stringify(addedItems));

		if (addedItems.length === 0) {
			navigate("/select-food");
		}
	}, [addedItems, navigate]);


	useEffect(() => {
		if (storedConfirmSeat) {
			setDeliveryConfirmSeat(JSON.parse(storedConfirmSeat));
		}
	}, [storedConfirmSeat]);

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	}, []);

	const handleSelected = () => {
		if (screenType && screenType !== "NORMAL" && TransactionType === "OnlyFB" && seatdetails?.seatrow) {
			setSelected("radio1");
			return;
		} else if (TransactionType === "OnlyFB" && fnb_qr !== "YES") {
			if (seatdetails?.screenName === undefined) {
				localStorage.removeItem("seatdetails");
			}
			setSelected("radio2");
			return;
		}

		// Check seat availability in different sources (seatdetails, seatsArray, deliveryConfirmSeat)
		const seatna = seatdetails?.seatrow && seatdetails?.seatno
			? `${seatdetails.seatrow}${seatdetails.seatno}`
			: seatsArray.length > 0 && seatDetailData?.[0]?.seats
				? seatDetailData?.[0]?.seats
				: deliveryConfirmSeat?.[0]?.seatno || "";

		// Set radio button selection based on the seat availability
		if (seatna && selectedTheater?.fbDeliveryOnSeat) {
			setSelected("radio1");
		}
		if (selected === "radio2") {
			localStorage.removeItem("seatdetails");
			setSelected("radio2");
		}
	};

	useEffect(() => {
		const seatInfo = renderSeatInfo() || "";
		const selectRadioClick = localStorage.getItem("selectRadioClick");
		setSelected(selectRadioClick) || setSelected();
		if (window.matchMedia("(max-width: 1024px)").matches) {
			if (!getWindowWidth && (selectedTheater?.fbDeliveryOnSeat && seatInfo === "" && TransactionType !== "OnlyFB" && selected === undefined)) {
				setSelected();
				localStorage.removeItem("selectRadioClick");
			} else if (TransactionType) {
				if (selectedTheater?.fbDeliveryOnSeat === false) { setSelected("radio2"); }
				handleSelected();
			}
		} else {
			setSelected("radio2");
		}

	}, [seatDetailData, seatdetails, deliveryConfirmSeat, TransactionType]);

	useEffect(() => {
		if (selected === "radio2") {
			let dataLayer = window["dataLayer"] || [];
			dataLayer.push({ event: 'food_pickup_from_counter' });
		}
	}, [selected])

	useEffect(() => {
		if (addedItems.length > 0 && selectedMovie) {
			const maxTime = maxPreparationTime(addedItems, selectedMovie);
			setPrepTime(maxTime);
		}
	}, [addedItems, selectedMovie]);

	const maxPreparationTime = (addedItems, selectedMovie) => {
		if (!selectedMovie || addedItems.length === 0) return 0;

		const capTime = selectedMovie.prepareCapTimeinMin;
		const defaultTime = selectedMovie.prepareDefaultTimeinMin;

		const maxPrepTime = Math.max(...addedItems.map(item => item.preparationTime || 0), 0);
		const totalQuantity = addedItems.reduce((sum, item) => sum + (item.quantity || 0), 0);
		let preparationTimes = addedItems.map(item => (item.preparationTime || 0) * (item.quantity || 1));
		let totalPrepTime = preparationTimes.reduce((sum, time) => sum + time, 0);

		if (totalQuantity === 1) {
			return Math.max(maxPrepTime, defaultTime);
		}

		if (totalQuantity === 2) {
			return Math.max(maxPrepTime, defaultTime);
		}

		let finalMaxTime = (totalPrepTime / 2) * 1.5;
		if (capTime > 0 && finalMaxTime > capTime) {
			finalMaxTime = capTime;
		}

		finalMaxTime = Math.max(finalMaxTime, defaultTime);

		return parseInt(finalMaxTime);
	};



	const fnbPaymentDetailsAPI = async (offer, totalPrice, fnAllData, prepTime) => {
		const seatna = selected === "radio2"
			? addFoodItems
				? addFoodItems?.orderTicket?.seats || addFoodItems?.seats
				: ""
			: (seatdetails?.seatrow && seatdetails?.seatno)
				? `${seatdetails.seatrow}${seatdetails.seatno}`
				: (deliveryConfirmSeat?.length > 0 ? deliveryConfirmSeat[0]?.seatno : "") || "";

		const filmId = selected === "radio2"
			? addFoodItems
				? addFoodItems?.orderFilmCinema?.filmId || addFoodItems?.filmId
				: ""
			: seatdetails
				? seatdetails?.filmId
				: (deliveryConfirmSeat?.length > 0 ? deliveryConfirmSeat[0]?.filmId : "") || "";

		const addFoodShowtime = addFoodItems ?
			addFoodItems?.orderTicket
				? parse(addFoodItems?.orderTicket?.showTime, "EEE, MMM dd, hh:mm a", new Date())
				: parse(addFoodItems?.showTime, "yyyy-MM-dd HH:mm:ss.S", new Date())
			: ""
		const formatDate = addFoodItems
			? format(new Date(addFoodShowtime), "yyyy-MM-dd")
			: seatDetailData?.[0]?.showTime
				? format(new Date(seatDetailData?.[0]?.showTime), "yyyy-MM-dd")
				: "";

		const formatTime = addFoodItems
			? format(new Date(addFoodShowtime), "hh:mm a")
			: seatDetailData?.[0]?.showTime
				? format(new Date(seatDetailData?.[0]?.showTime), "hh:mm a")
				: "";

		const pickUpDate = seatdetails
			? seatdetails?.pickUpDate
			: addFoodItems
				? `${formatDate}T${formatTime}`
				: (seatDetailData?.length > 0 ? `${formatDate}T${formatTime}` : "") || "";

		const screenNameRes = selected === "radio2"
			? addFoodItems
				? addFoodItems?.orderTicket?.audi || addFoodItems?.audi
				: ""
			: seatdetails?.screenName
				? `${seatdetails.screenName}`
				: (deliveryConfirmSeat?.length > 0 ? deliveryConfirmSeat[0]?.audi : "") || "";

		const screenId =
			addFoodItems?.orderTicket?.screenId > 0
				? addFoodItems.orderTicket.screenId
				: addscreenId?.screenId;

		const screenIdRes = addFoodItems
			? screenId
			: seatdetails
				? seatdetails?.screenId
				: 0;

		const bookingIdRes = addFoodItems
			? addFoodItems?.orderIdEx || addFoodItems?.bookingId
			: bookingId

		const genreRes = seatDetailData ? seatDetailData?.[0]?.genres : seatdetails?.genres;

		const languagesRes = seatDetailData ? seatDetailData?.[0]?.languages : seatdetails?.languages;

		const filmNameRes = seatDetailData ? seatDetailData?.[0]?.filmName : seatdetails?.filmName;

		const movieImageUrl = seatdetails?.seatrow
			? seatdetails?.movieImageUrl
			: seatDetailData
				? seatDetailData?.[0]?.filmUrl
				: "";

		const currentDateTime = `${FinalBookingDate} ${FinalBookingTime}`;
		const screenType =
			(currExperience &&
				(currExperience.includes("GOLD") ||
					currExperience.includes("LUXE") ||
					currExperience.includes("INSIGNIA") ||
					currExperience.includes("DIRECTOR")))
				? currExperience
				: seatdetails ? seatdetails?.screenType : "NORMAL";
		// const maxPreparationTime = addedItems.reduce((max, item) => {
		// 	return item.preparationTime > max ? item.preparationTime : max;
		// }, 0);

		const gaTagData = {
			movieName: filmNameRes,
			movieId: filmId,
			theaterName: selectedTheater?.name,
			selectedDate: pickUpDate ? pickUpDate : format(new Date(), "yyyy-MM-dd hh:mm a"),
			selectedSeats: seatna,
			genre: genreRes,
			languages: languagesRes,
			variant: screenNameRes,
			qty: addedItems?.length
		}
		localStorage.setItem("gaTagData", JSON.stringify(gaTagData));

		try {
			const response = await axios.post(
				`${appConstants.base_url}v1/fnb/fnbSaveFoodDetailsv2`,
				{
					qr: seatdetails?.fnb_qr === "YES" ? true : false || false,
					bookType: bookType,
					ccode: theatreId,
					screenType: screenType,
					audi: screenNameRes || "",
					deliveryMode: selected === "radio1" ? "ONSEAT" : "PICKUP" || "PICKUP",
					showTime: currentDateTime,
					pickUpDate: pickUpDate || "",
					seatNumber: seatna || "",
					screenId: screenIdRes || 0,
					filmId: filmId || "",
					transId: transId,
					foodType: bookType === "BOOKING" ? "" : TransactionType === "InCinemaFB" ? "ONSEAT" : "ADDFOOD",
					food: fnAllData,
					deliveryModeType: selectedOption,
					preparationTime: prepTime,
					bookingId: HaptikBookingid ? HaptikBookingid : bookingIdRes,
					dtmSource: localStorage.getItem("dtm_source") || ' '
				},
				{
					headers: {
						Authorization: authToken,
						"Content-Type": "application/json",
						chain: theme === "inoxTheme" ? "INOX" : "PVR",
						appVersion: appConstants.av,
						platform: appConstants.pt,
						country: appConstants.cname,
					},
				}
			);
			// setCheckoutLoading(false);

			if (response.data.result === "success") {
				if (bookType === "FOOD") {
					localStorage.setItem("transid", response.data.output.transId);
					localStorage.setItem("bookingid", response.data.output.bookingId);
					localStorage.setItem("onlyFooddata", JSON.stringify(response.data.output));
				}

				localStorage.setItem("en_bid", response.data.output.en_bid);
				localStorage.setItem("tickettype", "food");
				localStorage.removeItem("fnbSaveFoodDetailsError");
				if (bookType !== "BOOKING") localStorage.setItem("paymentOptions", 1);
				dispatch(
					setGrandTotalamount({
						cutPrice: finalAmount || finalAmount === 0 && !isNaN(finalAmount)
							? response?.data?.output?.totalPrice?.toFixed(2)
							: 0,
						finalPrice: finalAmount || finalAmount === 0 && !isNaN(finalAmount)
							? finalAmount
							: response?.data?.output?.totalPrice?.toFixed(2) //totalPrice,
					})
				);


				if (offer?.id) {
					getApplyData(offer, response.data.output.transId, response.data.output.bookingId);
					// navigate("/offers")
				} else {
					if (appliedVocher?.resOffer?.output?.p && finalAmount === 0 && !isNaN(finalAmount)) {
						await getFinalTicket();
					} else {
						if (appConstants.pt == "MSITE") {
							navigate(`/m.payment/${localStorage.getItem("cinema_name")}`, {
								state: {
									bookingId: bookingId,
									transId: transId,
									bookType: "FOOD",
									// paymentOptions: paymentOptions,
								},
							});
						} else {
							navigate(`/payment/qr`, {
								state: {
									bookingId: bookingId,
									transId: transId,
									bookType: "FOOD",
									// paymentOptions: paymentOptions,
								},
							});
						}
					}
				}
				if (selectedTheater?.name) { localStorage.setItem("cinema_name", selectedTheater?.name); }
				if (
					journeyvalue === "Only_Food" ||
					journeyvalue === "Add_Food" ||
					localStorage.getItem("gatagbookingtype") === "Food_QR"
				) {
					const langGenreTimeSeats = `${selectedMovie?.orderFilmCinema?.language || ''} / ${selectedMovie?.orderFilmCinema?.genre || ''} ${selectedMovie?.showTime || localStorage.getItem("FoodPickupDateTime") || new Date().toLocaleString('en-IN', { hour12: true, timeZone: 'Asia/Kolkata' })} / ${selectedMovie?.orderTicket?.seats || ''}`;
					const Foodvalue = localStorage.getItem("gatagbookingtype") === "Food_QR" ? "Only_Food" : (selectedMovie?.showTime ? "Add_Food" : "Only_Food");

					hitBeginCheckout(
						"begin_checkout",
						"INR",
						!isNaN(finalAmount) && finalAmount !== null ? Number(finalAmount) : Number(totalPrice),
						Foodvalue,
						localStorage.getItem("discountAmount"), // discount
						localStorage.getItem("discount_type"), // discount_type
						appConstants.cinemaChain, // movie_item_brand
						localStorage.getItem("filimname") || localStorage.getItem("movie_name"), // movie_item_name
						localStorage.getItem("movieid"), // movie_item_id
						selectedMovie?.orderFilmCinema?.filmName || "", // movie_item_list_name
						selectedMovie?.orderFilmCinema?.filmId || "", // movie_item_list_id
						"Movie", // movie_item_category
						localStorage.getItem("gatagbookingtype") || "", // movie_item_category2
						getJourneyValue(addedItems) || "", // movie_item_category3
						localStorage.getItem("cinema_name") || "", // movie_item_category4
						`${selectedMovie?.orderFilmCinema?.language || ''} / ${selectedMovie?.orderFilmCinema?.genre || ''} ${selectedMovie?.showTime || ''} / ${selectedMovie?.orderTicket?.seats || ''}`, // movie_item_category5
						Number(localStorage.getItem("seatPrice")) || 0, // movie_price
						selectedMovie?.orderTicket?.numOfSeats || 0, // movie_quantity
						selectedMovie?.orderFilmCinema?.format || localStorage.getItem("format") || "", // movie_item_variant
						localStorage.getItem("city") || "", // movie_location_id
						appConstants.cinemaChain, // food_item_brand
						addedItems.map(item => item.ItemName).join(","), // foodNames
						addedItems.map(item => item.ItemID).join(","), // foodIds
						"Food", // food_item_category
						localStorage.getItem("gatagbookingtype") || "", // food_item_category2
						getJourneyValue(addedItems) || "", // food_item_category3
						selectedTheater?.name || "", // food_item_category4
						langGenreTimeSeats || localStorage.getItem("FoodPickupDateTime") || "", // food_item_category5
						addedItems.map(item => Number(item.price) / 100), // foodPrices (converted to rupees if needed)
						addedItems.map(item => Number(item.quantity) || 0), // foodQuantities
						localStorage.getItem("city") || "" // food_location_id
					);
				}


				fnAllData?.forEach(item => {
					IsEvent({
						itemAction: window.Evergage?.ItemAction?.AddToCart,
						cart: {
							singleLine: {
								Product: {
									_id: item.itemId,
									price: (item.price / 100) * item.quantity,
									quantity: item.quantity,
								},
							},
						},
					});

					// IsEvent({
					// 	action: "Product Added To Cart",
					// 	user: {
					// 		attributes: {
					// 			lastAddedToCart: item.itemId, 
					// 		},
					// 	},
					// });
				});

			} else {
				sweetAlertError(response.data.msg);
				localStorage.setItem("fnbSaveFoodDetailsError", response.data.msg);
			}
		} catch (error) {
			console.error("Error fetching FNB payment details:", error);
			localStorage.setItem("fnbSaveFoodDetailsError", error);
		} finally {
			setPayDetailLoading(false);
		}
	};


	const getApplyData = async (offers, transid, bookingid) => {
		const { vouId, vouDesc, vouType, category, type, tnc } = offers
		setLoading(true);
		try {
			const voutypedata =
				vouType?.toLowerCase() === 'auto'
					? 'AUTOVOUCHER'
					: vouType?.toLowerCase() === 'binbased'
						? 'BANKOFFER'
						: vouType?.toLowerCase() === 'promocode'
							? 'PROMOCODE'
							: 'AUTOVOUCHER';

			const unlockData = vouType?.toLowerCase() === 'auto' ? false : '';
			const cardData = vouType?.toLowerCase() === 'binbased' ? cardDetailsData?.cardNumber : '';
			const cardTypeData = vouType?.toLowerCase() === 'binbased' ? cardDetailsData?.cardType : '';
			const vouIdData = vouType?.toLowerCase() === 'promocode' ? 0 : vouId;
			const fnb_qrData = seatdetails?.fnb_qr === 'YES' || TransactionType === 'InCinemaFB' ? 'YES' : 'NO';
			const qrsData = fnb_qrData === 'YES';
			const bookingType = bookType === "BOOKING" ? "BOOKING" : "FOOD";

			const formData = {
				ccode: theatreId || '',
				bookingId: bookingid || '',
				transId: transid || '',
				bookType: bookingType,
				couponId: vouIdData,
				coupon: vouId,
				couponType: voutypedata || '',
				qr: fnb_qrData,
				card: cardData || '',
				cardType: cardTypeData || '',
				mobile: userInfoData?.data?.mob || '',
				otp: '',
				unlock: unlockData,
				qrs: qrsData,
			};

			const state = { ...formData, tnc };

			// Navigate if certain conditions match
			if (category?.toLowerCase() === 'offer' && type?.toLowerCase() === 'bank' && vouType?.toLowerCase() === 'binbased') {
				const nameURL = encodeURIComponent(vouDesc.replace(/\s+/g, '-').toLowerCase());
				navigate(`/bankoffer/${nameURL}`, { state: { bankCurrentDataState: state } });
				return;
			}

			if (
				category?.toLowerCase() === 'voucher' &&
				type?.toLowerCase() === 'normal' &&
				vouType?.toLowerCase() === ''
			) {
				navigate(`/promocode`, { state: { promoCodeState: state } });
				return;
			}

			// API call
			const response = await axios.post(
				`${appConstants.base_url}v1/payment/coupon/apply`,
				formData,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: authToken,
						chain: localStorage.getItem('theme') === 'inoxTheme' ? 'INOX' : 'PVR',
						appVersion: appConstants.av,
						platform: appConstants.pt,
						country: appConstants.cname,
					},
				}
			);

			if (response?.data.result === 'success') {
				const discAmt = parseFloat(response?.data?.output?.di);
				const discountAmount = parseFloat(response?.data?.output?.dp);

				if (response?.data?.output?.p && discountAmount === 0 && !isNaN(discountAmount)) {
					await getFinalTicket();
				} else {
					dispatch(
						setGrandTotalamount({
							cutPrice: discountAmount || discountAmount === 0 && !isNaN(discountAmount)
								? response?.data?.output?.fp
								: 0,
							finalPrice: discountAmount || discountAmount === 0 && !isNaN(discountAmount)
								? discountAmount
								: response?.data?.output?.fp
						})
					);
				}
				setRemoveApplied(true);
				setShowOffer(true);
				const appliedOfferData = { vouDesc, vouId, resOffer: response.data, vouPayType: voutypedata, discOn: appliedOffer?.discOn, discValue: appliedOffer?.discValue };
				localStorage.setItem('AppliedOfferData', JSON.stringify(appliedOfferData));
				const existGetAllFnbData = JSON.parse(localStorage.getItem('getAllFnbData') || '{}');
				existGetAllFnbData.AppliedOfferDataNew = appliedOfferData;
				appliedOfferData.ApplyOfferRespn = response?.data;
				localStorage.setItem('getAllFnbData', JSON.stringify(existGetAllFnbData));
			} else {
				localStorage.removeItem('AppliedOfferData')
				setApplyFailed(true)
				sweetAlertError(response.data.msg);
			}
		} catch (error) {
			sweetAlertError('Something went wrong!');
			console.error('Error details:', error.response ? error.response.data : error.message);
		} finally {
			setLoading(false);
		}
	};

	const seatDetailsAPI = async () => {
		setLoadingSeat(true);
		// const formData = {
		// 	upcomingMovies: false  //`2024-09-16 19:45:00.000000`
		// };

		try {
			const response = await axios.post(
				`${appConstants.base_url}v1/fnb/getExistingBookings?upcomingMovies=false`,
				{},
				{
					headers: {
						"Content-Type": "application/json",
						Authorization: authToken,
						chain: localStorage.getItem("theme") === "inoxTheme" ? "INOX" : "PVR",
						appVersion: appConstants.av,
						platform: appConstants.pt,
						country: appConstants.cname,
					},
				}
			);
			if (response.data.result === "success") {
				setSeatDetailData(response.data.output);
				formattedShowEndTime(response.data.output);
				if (response.data.output.length > 0) {
					const matchingTheater = response.data.output.find((item) => item?.theaterId === theatreId);
					if (matchingTheater) {
						handleYourSeatModalShow();
					} else {
						handleYourSeatManualShow();
					}
				} else {
					handleYourSeatManualShow();
				}
			} else {
				handleYourSeatManualShow();
			}
		} catch (error) {
			sweetAlertError("Something went wrong!");
			console.error("Failed to fetch seat details:", error);
		} finally {
			setLoadingSeat(false);
		}
	};

	const handleImageError = (e) => {
		e.target.src = noImg; // Set fallback image if the original image fails
	};

	const handleRadioTypeClick = (id) => {
		if (appliedVocher) handleRemoveOfferApplied();
		if (id === "radio2") {
			localStorage.removeItem("seatdetails");
			localStorage.removeItem("DeliverytoSeatData");
			setDeliveryConfirmSeat(null);
			setShowSeatInfo(false);
			setSelected("radio2");
			setSelectedSeat('');
			setScreenName('');
		} else {
			setShowSeatInfo(true);
		}
		localStorage.setItem("selectRadioClick", id);
		setSelected(id);
	};
	const handleExpand = () => {
		setExpand(!expand);
	};

	const handleRemoveOfferApplied = async () => {
		try {
			setLoading(true);

			const voutypedata = appliedVocher?.vouPayType?.toLowerCase() === "auto" ? "AUTOVOUCHER" : appliedVocher?.vouPayType?.toLowerCase() === "binbased" ? "BANKOFFER" : appliedVocher?.vouPayType?.toLowerCase() === "promocode" ? "PROMOCODE" : "";
			const unlockData = appliedVocher?.vouPayType?.toLowerCase() === "auto" ? false : "";
			const cardData = appliedVocher?.vouPayType?.toLowerCase() === "binbased" ? cardDetailsData?.cardNumber : "";
			const cardTypeData = appliedVocher?.vouPayType?.toLowerCase() === "binbased" ? cardDetailsData?.cardType : "";
			const vouIdData = appliedVocher?.vouPayType?.toLowerCase() === "promocode" ? 0 : appliedVocher?.vouId;
			const qrsData = seatdetails?.fnb_qr === "YES" ? true : false;
			const fnb_qrData = TransactionType === "InCinemaFB" ? "YES" : "NO";
			// const fnb_qrData = seatdetails?.fnb_qr === "YES" ? "YES" : TransactionType === "InCinemaFB" ? "YES" : "NO";

			const formData = {
				ccode: theatreId || "",
				bookingId: bookingId,
				transId: transId,
				bookType: "FOOD",
				couponId: vouIdData,
				coupon: appliedVocher?.vouId,
				couponType: voutypedata || "",
				qr: fnb_qrData,
				card: cardData || "",
				cardType: cardTypeData || "",
				mobile: userInfoData?.data?.mob || '',
				otp: "",
				qrs: qrsData
			};
			const response = await axios.post(
				`${appConstants.base_url}v1/payment/coupon/remove`,
				formData,
				{
					headers: {
						"Content-Type": "application/json",
						Authorization: authToken,
						chain: localStorage.getItem("theme") === "inoxTheme" ? "INOX" : "PVR",
						appVersion: appConstants.av,
						platform: appConstants.pt,//"WEBSITE", //,
						country: appConstants.cname
					},
				}
			);

			if (response.data?.result === "success") {
				setRemoveApplied(false);
				cancelTrnsService()
				localStorage.removeItem("AppliedOfferData");

				const existGetAllFnbData = JSON.parse(localStorage.getItem("getAllFnbData"));

				delete existGetAllFnbData.AppliedOfferDataNew;

				localStorage.setItem("getAllFnbData", JSON.stringify(existGetAllFnbData));

				// sweetAlertSuccess(response?.data?.msg);
			} else {
				sweetAlertError(response?.data?.msg || "Failed to remove offer.");
			}
		} catch (error) {
			const errorMsg =
				error.response?.data?.message ||
				error.message ||
				"Something went wrong!";
			sweetAlertError(errorMsg);
			console.error("Failed to remove offer:", errorMsg);
		} finally {
			setLoading(false);
		}
	};

	const cancelTrnsService = async () => {
		const postData = {
			ccode: theatreId,
			qr: TransactionType === "OnlyFB" ? "NO" : "YES",
			bookType: bookType,
			transId: localStorage.getItem("transid") || 0,
			bookingId: localStorage.getItem("bookingid") || 0,
			//ccode: cinemacode,
			donate: "",
			flexi: 0,
			cancelUnpaid: true,
		};

		await axios
			.post(`${appConstants.base_url}v1/booking/ticketing/cancel`, postData, {
				headers: {
					chain: theme === "inoxTheme" ? "INOX" : "PVR",
					city: city,
					Authorization: authToken,
					appVersion: appConstants.av,
					platform: appConstants.pt,
					country: appConstants.cname,
				},
			})
			.then((res) => {

				localStorage.removeItem("isQR");
				localStorage.removeItem("bookingid");
				localStorage.removeItem("transid");
				localStorage.removeItem("DeliverytoSeatData");

			})
			.catch((error) => {
				const err = error?.response;
				if (err?.status === 403) {
					refraceTokenService();
					console.log(
						"Forbidden: You do not have permission to access this resource."
					);
				} else {
					console.log("Error:", error.message);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		console.log(selectedSeat);
	}, [selectedSeat]);

	const handleSeatClick = (seat) => {
		setSelectedSeat(seat);
		setErrMsg(false);
	};


	const renderSeatInfo = () => {
		if (seatsArray.length > 0 || storedConfirmSeat) {
			if (seatdetails) {
				return `${seatdetails.screenName}, ${seatdetails.seatrow}${seatdetails.seatno}`;
			} else {
				return (deliveryConfirmSeat && deliveryConfirmSeat.length > 0) && deliveryConfirmSeat?.map((confirmedItem) => `${confirmedItem?.audi}, ${confirmedItem?.seatno}`)?.join(", ");
			}
		}

		return seatdetails && (seatdetails.screenName || seatdetails.seatrow)
			?
			<p className="confirmSeat">
				{seatdetails?.screenName && `${seatdetails?.screenName},`} {seatdetails?.seatrow}{seatdetails?.seatno}
			</p>
			: <p className='dfltxt'>Introduced feature at <b>zero</b> additional cost</p>;
	};

	const handleClick = async () => {
		handleRadioTypeClick("radio1");
		setErrMsg(false);
		try {
			await seatDetailsAPI();


		} catch (error) {
			// Hide loader if there's an error
			setLoading(false);

			console.error("Error fetching seat details:", error);
			// Handle any errors that may occur while fetching seat details
		}
	};

	const getFinalTicket = async () => {
		try {

			const postData = {
				qr: localStorage.getItem("isQR") && isMobile ? "YES" : "NO",
				bookType: "FOOD",
				transId: transId,
				bookingId: bookingId,
				flowType: "FOOD",
				ccode: localStorage.getItem("theaterId"),
			};

			const response = await axios.post(
				`${appConstants.base_url}v1/booking/ticketing/completed`,
				postData,
				{
					headers: {
						Authorization: authToken || "",
						chain: localStorage.getItem("theme") === "inoxTheme" ? "INOX" : "PVR",
						city: localStorage.getItem("city"),
						appVersion: appConstants.av,
						platform: appConstants.pt,
						country: appConstants.cname,
					},
				}
			);

			const dt = response.data;
			if (dt.result === "success") {
				const ndt = dt.output;
				setFinalTicket(ndt);
				localStorage.setItem("orderId", ndt.bookingId);
				navigate(`/order-received`);
				if (ndt?.chatbot === "true") {
					localStorage.setItem("chatbotticketbooked", ndt?.chatbot);
					localStorage.setItem("Welcomemessage", "true");
					localStorage.setItem("finalbooking_Id", ndt?.bookingId);
				}

				localStorage.removeItem("transId");
				localStorage.removeItem("booking_type");
				localStorage.removeItem("isQR");
			} else {
				setIsBadTransaction(true);
				setShowAlert(true);
				setErrorMsg(dt);
			}
		} catch (error) {
			const err = error?.response;
			if (err?.status === 403) {
				refraceTokenService();
				console.log(
					"Forbidden: You do not have permission to access this resource."
				);
			} else {
				console.error("Error:", error?.message);
			}

			setIsBadTransaction(true);
			setShowAlert(true);
			setErrorMsg("There is a network failure.");
		} finally {
			// setLoading(false);
		}
	};


	const paymentHandle = async (offer) => {
		try {
			const offerDetails = offer?.id ? offer : "";
			if (!selected && bookType !== "BOOKING") {
				const messages = JSON.parse(localStorage.getItem("messages"));
				sweetAlertError(messages.deliveryLocation);
				return
			}
			if (offer?.id) setPayDetailLoading(true)
			else setPaymentLoading(true);


			const itemIDs = addedItems.map(item => item.ItemID);
			const transformedFoodItems = addedItems?.map(item => {
				const validParentId = item?.parentUpsellId && itemIDs?.includes(item?.parentUpsellId) ? item?.parentUpsellId : "";
				return {
					itemId: item?.ItemID,
					name: item?.ItemName,
					quantity: item?.quantity,
					price: item?.price || 0,
					veg: item?.IsVeg,
					parentId: validParentId,
					foodType: item?.foodType,
					itemType: validParentId ? 1 : 2,
					// preparationTime: item?.preparationTime,
					addons: item?.AddOnItem
						? item?.AddOnItem.map(addon => ({
							itemId: addon.addOnItemId,
							name: addon.name,
							price: addon.price || 0,
							quantity: addon.quantity,
						}))
						: [],
				};
			});

			const cartData = transformedFoodItems.map(item => ({
				itemId: item?.itemId,
				name: item?.name,
				quantity: item?.quantity,
				price: item?.price,
				veg: item?.veg ? true : false,
				parentId: item?.parentId,
				foodType: item?.foodType,
				itemType: item?.parentId ? 1 : 0,
				// preparationTime: item?.preparationTime,
				addons: item?.addons,
			}));

			if (cartData.length > 0) {
				const data = {
					fnAllData: cartData,
					FinalBookingDate: FinalBookingDate,
					FinalBookingTime: FinalBookingTime,
				};
				localStorage.setItem("getAllFnbData", JSON.stringify(data));
			} else {
				const messages = JSON.parse(localStorage.getItem("messages"));
				sweetAlertError(messages.emptyCart || "Your cart is empty.");
			}

			const totalPrice = addedItems.reduce((total, item) => {
				const totalPrice = parseInt(item?.price) * item?.quantity || 0;
				const addonPrice = item?.AddOnItem?.reduce((addonTotal, addon) => {
					return addonTotal + (addon?.price || 0) * addon?.quantity;
				}, 0);
				return total + totalPrice + addonPrice;
			}, 0);

			await fnbPaymentDetailsAPI(offerDetails, (totalPrice / 100).toFixed(2), cartData, prepTime);
		} catch (error) {
			console.error("Error processing payment:", error);
		} finally {
			setPaymentLoading(false);
		}
	};

	const sweetAlertSuccess = (msg) => {
		setAlertDetails({
			show: true,
			type: "success",
			title: "Success!",
			message: msg,
		});
	};

	const sweetAlertError = (msg) => {
		setAlertDetails({
			show: true,
			type: "error",
			title: "Error!",
			message: msg,

		});
	};



	const hideAlert = () => {
		setAlertDetails({ show: false });
		if (applyFailed) {
			if (isMobile) {
				navigate(`/m.payment/${localStorage.getItem("cinema_name")}`);
			} else {
				navigate(`/payment/${localStorage.getItem("cinema_name")}`);
			}
		}
		// navigate("/select-food");
		// localStorage.removeItem("cartItems");
	}
	const formattedShowEndTime = (data) => {
		if (data.length > 0) {
			const showTime = parse(data?.[0]?.showTime, "yyyy-MM-dd HH:mm:ss.S", new Date());
			const endTime = parse(data?.[0]?.endTime, "yyyy-MM-dd HH:mm:ss.S", new Date());
			const formattedShowTime = showTime && isValid(showTime) ? format(showTime, "hh:mm a") : "-";
			const formattedEndTime = endTime && isValid(endTime) ? format(endTime, "hh:mm a") : "-";
			setFormattedShowTime(formattedShowTime);
			setFormattedEndTime(formattedEndTime);
		}
	}

	const cartTransprantBtn = {
		color: "black",
		backgroundColor: "transparent",
		border: "1px solid #EDE8E9",
	};

	// Helper function to all items count
	let countAllItems = (() => {
		let i = 0;
		addedItems &&
			addedItems.forEach((item) => {
				i = i + item.quantity;
				if (item?.AddOnItem) {
					item?.AddOnItem.forEach((addon) => (i = i + addon.quantity));
				}
			});
		return i;
	})();

	const removeFromCart = (id) => {
		const numOfItems = cartItemIds.current.filter((itemId) => itemId === id);

		if (numOfItems.length === 1) {
			setAddedItems((prevItem) => {
				let stateCopy = [...prevItem];
				let removeInd = -1;
				stateCopy.map((item, index) => {
					if (item.ItemID === id) {
						item.quantity--;
						if (item?.AddOnItem?.length) {
							let addOns = [...item.AddOnItem];
							addOns.map((e) => {
								e.quantity--;
							});
							item.AddOnItem = addOns;
						}
						if (item.quantity <= 0) {
							removeInd = index;
						}
					}
				});
				if (removeInd >= 0) {
					stateCopy.splice(removeInd, 1);
				}
				localStorage.setItem("cartItems", JSON.stringify(stateCopy));
				return stateCopy;
			});
		} else {
			navigate("/select-food");
		}
	};

	const addToCart = (item) => {
		let addedItemsCopy = [...addedItems];
		let isSame = false;
		const uniqueKey = item.id + (item.addonIds?.length > 0 ? item.addonIds.sort().join("-") : "");
		addedItemsCopy.forEach((item) => {
			const itemKey = item.ItemID + (item.addonIds?.length > 0 ? item.addonIds.sort().join("-") : "");

			if (itemKey === uniqueKey) {
				// if ((bookType === "BOOKING" && item.quantity >= seatCount) || (bookType !== "BOOKING" && item.quantity >= 10)) {
				if (item.quantity >= 10) {
					sweetAlertError(messages?.itemQuantityLimit);
				}

				if (addedItemsCopy.reduce((total, i) => total + i.quantity, 0) >= seatCount) {
					sweetAlertError(messages?.itemQuantityLimit);
					return;
				}
				item.quantity++;
				item.AddOnItem.forEach((addon) => addon.quantity++);
				isSame = true;
			}
		});

		if (isSame) {
			setAddedItems(addedItemsCopy);
			return;
		}

		const newItem = item?.h ? {
			ItemID: item.id || item.comboItemId,
			ItemName: item.h || item.comboItemName,
			Categories: item?.ct,
			IsVeg: item.veg,
			quantity: 1,
			price: item.dp || parseInt(item.comboItemRate) * 100,
			foodType: item.foodType,
			PrimaryItemID: item.id || item.comboItemId,
			itemImageURL: item.i,
			sgst: item.sgst,
			cgst: item.cgst,
			isCustmization: item.addOn === true ? true : false,
			preparationTime: item.preparationTime,
			upgradable: item.upgradable,
			upsellable: item.upsellable,
			upgradeItems: item?.upgradeItems
				? item?.upgradeItems?.map(upgrade => ({
					ItemID: upgrade.upgradeItemId,
					upgradeItemName: upgrade.upgradeItemName,
					upgradeItemRate: upgrade.upgradeItemRate
				})) : [],
			upsellItems: item?.upsellItems
				? item?.upsellItems?.map(upsell => ({
					upsellItemId: upsell.upsellItemId,
					upsellItemName: upsell.upsellItemName,
					upsellItemRate: upsell.upsellItemRate
				})) : [],


			upgradeItems: [],
			upsellItems: [],
			parentUpsellId: item.parentUpsellId || null,

			preparationType: item.preparationType,
			addonIds: item.addonIds || [],
			AddOnItem: item.addOnItems
				? item.addOnItems.map((e) => ({
					addOnItemId: e.addOnItemId,
					name: e.addOnItemName,
					price: e.addOnItemRate,
					quantity: 1,
				}))
				: [],

		} : item;
		console.log(newItem, "newitem")
		const updatedCart = [...addedItems, newItem];
		setAddedItems(updatedCart);
	}

	const updateAddedItems = (itemId, count) => {
		setAddedItems((prevItems) => ({
			...prevItems,
			[itemId]: count,
		}));
	};

	const handleUpgradeRadioClick = (index) => {
		setActiveIndex(index);
		selectedItem.quantity = index + 1;
	};

	const handleUpgradeConfirm = () => {
		const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
		const parentIndex = cartItems.findIndex(
			(item) => item.ItemID === selectedItem.upgradeParentId
		);

		if (parentIndex !== -1) {
			const parentItem = cartItems[parentIndex];
			const remainingQuantity = parentItem.quantity - selectedItem.quantity;

			if (remainingQuantity > 0) {
				cartItems[parentIndex].quantity = remainingQuantity;
			} else {
				cartItems.splice(parentIndex, 1);
			}
		}

		const existingItemIndex = cartItems.findIndex(
			(item) => item.ItemID === selectedItem.ItemID
		);

		if (existingItemIndex !== -1) {
			cartItems[existingItemIndex].quantity += selectedItem.quantity;
		} else {
			cartItems.push({
				...selectedItem,
				quantity: selectedItem.quantity,
			});
		}
		handleUpgradeModalClose()
		// localStorage.setItem("cartItems", JSON.stringify(cartItems));
		setAddedItems(cartItems);
	};

	// Food & Ticket Side Bar
	const selectedFoodData = (data) => {

		if (bookType === "BOOKING") {
			if (!addedItems || addedItems.length === 0) return null;

			return addedItems.map((item, index) => {
				const checkItemPrice = item.price / 100;

				return (
					<div key={`${item.ItemID}-${index}`} className="Reco-card-main bookingfnbFood">
						<div className="fb-card-inn">
							<div className="Reco-item-view">
								{item.foodType === 1 ? (
									<svg className="fnb-itemVorN" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
										<rect x="0.5" y="0.5" width="13" height="13" rx="1.5" stroke="#149752" />
										<circle cx="6.99984" cy="6.99935" r="4.08333" fill="#149752" />
									</svg>
								) : item.foodType === 0 ? (
									<svg className="fnb-itemVorN" width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
										<rect x="0.961426" y="0.964844" width="10.0769" height="10.0769" rx="1.5" stroke="#87001B" />
										<path d="M9 8.80886H3L6.00011 3.18945L9 8.80886Z" fill="#87001B" />
									</svg>
								) : (
									<p className="emtyIcon"></p>
								)}

								{/* <img
              className="cartitemimg"
              src={item?.itemImageURL || noImg}
              alt={item?.itemName || "No image available"}
              onError={handleImageError}
            /> */}
							</div>

							<div className="Reco-item-desc">
								<p className="fb-itemName">{item?.ItemName}</p>
								{item.AddOnItem.length > 0 && (
									<em className="fnb-c-addons">
										Add-ons:
										{item.AddOnItem.map((addon, addonIndex) => (
											<p className="cart-addonP" key={addonIndex}>
												{addon.name} ₹{addon.price / 100} X {addon.quantity}
											</p>
										))}
									</em>
								)}
								<AddButton
									cartBtn={true}
									cartStyle={cartTransprantBtn}
									key={`${item.ItemID}-${index}-btn`}
									data={item}
									cartIndex={index}
									setAddedItems={setAddedItems}
									addedItems={addedItems}
									isCart={true}
									cartItemIds={cartItemIds.current}
									updateCount={addToCart}
									handleFoodInfoShow={() => handleFoodInfoShow(item)}
									handleCustomizfoShow={() => handleCustomizfoShow(item)}
									removeFromCart={removeFromCart}
									totalItems={countAllItems}
								/>
							</div>
							<div className="Customfb-btnDiv">
								<p className="fb-itemPrice">
									₹
									{(
										item.quantity * checkItemPrice +
										item.AddOnItem.reduce((sum, addon) => sum + addon.price * item.quantity, 0) /
										100
									).toFixed(2)}
								</p>
							</div>
						</div>
					</div>
				);
			});
		}
	};

	const calculateMovieSubTotal = (bookingType, totalTicketPrice, addedItems) => {

		if (bookingType === "BOOKING") {
			const ticketPrice = +totalTicketPrice?.replace(/,/g, "") || 0;
			const foodTotal = addedItems?.reduce((total, item) => {
				const totalPrice = (item?.price || 0) * item.quantity;
				const addonPrice = (item?.AddOnItem || []).reduce((addonTotal, addon) => {
					return addonTotal + ((addon?.price || 0) * addon.quantity);
				}, 0);
				return total + totalPrice + addonPrice;
			}, 0) || 0;

			return `${(ticketPrice + (foodTotal / 100)).toFixed(2)}`;
		} else {
			const foodTotal = addedItems?.reduce((total, item) => {
				const totalPrice = (item?.price || 0) * item.quantity;
				const addonPrice = (item?.AddOnItem || []).reduce((addonTotal, addon) => {
					return addonTotal + ((addon?.price || 0) * addon.quantity);
				}, 0);
				return total + totalPrice + addonPrice;
			}, 0) || 0;

			return `${(foodTotal / 100).toFixed(2)}`;
		}
	};

	const calculateGrandTotal = (
		bookingType,
		totalTicketPrice,
		convTotal,
		addedItems,
		item = false
	) => {
		let priceValue;
		const ticketPrice = +totalTicketPrice?.replace(/,/g, "") || 0;
		const convFee = +convTotal || 0;

		const addonPrice = addedItems?.reduce((total, item) => {
			const totalPrice = (item?.price || 0) * item.quantity;
			const addonTotal = (item?.AddOnItem || []).reduce((sum, addon) => {
				return sum + ((addon?.price || 0) * addon.quantity);
			}, 0);
			return total + totalPrice + addonTotal;
		}, 0) || 0;

		if (bookingType === "BOOKING") {
			priceValue = (ticketPrice + convFee + (addonPrice / 100));
		} else {
			priceValue = addonPrice / 100;
		}

		return item ? priceValue.toFixed(2) : (
			<span>
				{bookingType === "BOOKING" ? priceValue.toFixed(2) : priceValue}
			</span>
		);
	};

	const totalGrandAmount = removeApplied && finalAmount !== null && finalAmount !== undefined && !isNaN(finalAmount)
		? finalAmount
		: addedItems
			? (addedItems.reduce((total, item) => {
				const totalPrice = item?.price * item.quantity;
				const addonPrice = (item?.AddOnItem || [])?.reduce((addonTotal, addon) => {
					return addonTotal + (addon?.price * addon.quantity || 0);
				}, 0);
				return total + totalPrice + addonPrice;
			}, 0) / 100).toFixed(2)
			: "-"

	useEffect(() => {
		if (!appliedOffer) return;

		const min = Number(appliedOffer?.minTrnValue ?? 0);
		const max = Number(appliedOffer?.maxTrnValue ?? Number.MAX_SAFE_INTEGER);
		const amount = Number(totalGrandAmount);

		const isValid = amount >= min && amount <= max;

		if (!isValid && isChecked && !cua) {
			setIsChecked(false);
			setRemoveApplied(false);
		}
	}, [totalGrandAmount, appliedOffer]);
	// let cleanedOutlets = redemptionOutletRaw
	//     .replacingOccurrences(of: "&amp;", with: "&")
	//     .lowercased()
	//     .split(separator: ",")
	//     .map { $0.trimmingCharacters(in: .whitespaces) }

	// // --------------------------------------------
	// // UPDATED RULE: Only "incinema f&b" required.
	// // --------------------------------------------
	// let incinemaRequired = "incinema f&b"
	// guard cleanedOutlets.contains(incinemaRequired) else {
	//     return nil
	// }

	useEffect(() => {
		if (!fnbVouchers || fnbVouchers.length === 0) return;

		// const filtered = fnbCoupen.filter(item => item.bankVouType !== "BinBased" && item?.minTrnValue >= 0);

		const filtered = fnbVouchers; //.filter(item => item?.redemptionOutlet?.split(",").some(outlet => outlet.trim().includes("InCinema")));
		// const filtered = fnbVouchers.filter(item => item?.type?.toLowerCase() === "auto" && item?.category?.toLowerCase() === "voucher");

		if (filtered.length === 0) return;
		if (cua) setIsChecked(true);

		const eligibleOffers = filtered.filter(item => Number(totalGrandAmount) >= item.minTrnValue);

		const bestOffer = eligibleOffers.length > 0
			? eligibleOffers.reduce((prev, curr) => {
				if (curr.minTrnValue === prev.minTrnValue) {
					return curr.discValue > prev.discValue ? curr : prev;
				}
				return curr.minTrnValue > prev.minTrnValue ? curr : prev;
			})
			: null;

		const upcomingOffers = filtered
			.filter(item => item.minTrnValue > totalGrandAmount)
			.sort((a, b) => {
				if (a.minTrnValue === b.minTrnValue) {
					return b.discValue - a.discValue;
				}
				return a.minTrnValue - b.minTrnValue;
			});

		const nextOffer = upcomingOffers[0] || null;
		setAppliedOffer(bestOffer);
		setNearestOffer(nextOffer);

	}, [totalGrandAmount]);

	const handleToggleOffer = () => {
		setIsChecked(prev => !prev);
	};

	function applyOfferHighlighting(text) {
		if (!text) return text;

		const pattern = /(\d+)|(%|Rs|₹)/gi;

		return text.split(pattern).map((part, index) => {
			if (part && part.match(pattern)) {
				return (
					<span key={index} style={{ fontWeight: 600 }}>
						{part}
					</span>
				);
			}
			return <span key={index}>{part}</span>;
		});
	}

	const missingItems = clu?.filter(
		item => !cartItemIds.current.includes(item.id)
	);

	return (
		<>
			{getWindowWidth &&
				<div className="bg-white show-in-desktop-view" style={{ position: "sticky", top: "0", zIndex: "999" }}>
					<Navbar />
				</div>
			}
			{bookType === "BOOKING" &&
				<div className="fnbbreadcrb">
					<SeatLayoutBreadBrumb />
				</div>
			}
			<div className={`${bookType === "BOOKING" ? "ticketfnb row" : ""} ${currentClasses.fnbdeskdiv}`}>
				<div className={`${bookType === "BOOKING" ? "col-md-9 " : ""} ${currentClasses.fnbdeskdivInn}*`}>
					<div className={currentClasses.fnbdeskdivInn}>
						{loading ? (
							<FnbCheckoutSkeleton />
						) : (
							<>
								<FbHeader headname="Food Summary"
									locationName={addFoodItems ? addFoodItems?.orderFilmCinema?.theaterName : cinemaname || localStorage.getItem("theaterNamebot")}
									addressShow={true} />
								<div className="co-outer-maindiv">
									{/* {removeApplied && location && discAmt >= 0 && ( */}
									{(isChecked && appliedOffer?.discValue >= 0) &&
										<div iv className="fb-save-label">
											<p className="fb-save-lP">
												You'll be saving{" "}
												{appliedOffer?.discOn === "Value" ? "₹" : ""}
												{appliedOffer?.discValue}
												{appliedOffer?.discOn === "Per" ? "%" : ""}
												{" "} on the bill
											</p>
										</div>}
									{/* )} */}
									{addedItems && (
										<div className="co-outer">
											{addedItems && addedItems?.map(
												(item, index) => (
													<div key={index} className="buyItem-list">
														<div className="buyItem-listInn">
															<div className="co-itemName">
																{item?.foodType === 1 ?
																	<svg className="co-vNv" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
																		<rect x="0.5" y="0.5" width="13" height="13" rx="1.5" stroke="#149752" />
																		<circle cx="6.99984" cy="6.99935" r="4.08333" fill="#149752" />
																	</svg>
																	: item?.foodType === 0 ?
																		<svg className="co-vNv" width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<rect x="0.961426" y="0.964844" width="10.0769" height="10.0769" rx="1.5" stroke="#87001B" />
																			<path d="M9 8.80886H3L6.00011 3.18945L9 8.80886Z" fill="#87001B" />
																			<clipPath id="clip0_3452_1183">
																				<rect width="6" height="6" fill="#87001B" transform="translate(3 3)" />
																			</clipPath>
																		</svg>
																		:
																		<p className="emtyIcon"></p>
																}

																<div>
																	<p className="co-itemNameP">{item?.ItemName || item?.itemName}</p>
																	{item?.upgradeParentId && <span className='upgradeTag'>Upgraded</span>}
																</div>
															</div>
															<div className="co-itemName chkoutbtn">
																<AddButton
																	cartBtn={true}
																	cartStyle={cartTransprantBtn}
																	key={`${item.ItemID}-upgrade`}
																	data={item}
																	cartIndex={index}
																	setAddedItems={setAddedItems}
																	addedItems={addedItems}
																	isCart={true}
																	updateCount={addToCart}
																	removeFromCart={removeFromCart}
																	totalItems={countAllItems}
																	handleRemoveOfferApplied={handleRemoveOfferApplied}
																/>
																<p className="co-pricep">
																	₹
																	{((item?.quantity * item?.price) / 100
																		// (item?.AddOnItem?.reduce((sum, addon) => sum + (addon.price * addon.quantity) / 100, 0) || 0)
																	).toFixed(2)}
																</p>
															</div>
														</div>
														{item?.AddOnItem?.length > 0 &&
															<div className="co-addon-div" style={{ paddingLeft: "25px" }}>
																Add ons:
																{item?.AddOnItem.map((addon, index) => {
																	return (
																		<div key={index} className="co-addon-inndiv">
																			<span>
																				<em>{`${addon?.name} x ${addon?.quantity}`}</em>
																			</span>
																			<span style={{ fontFamily: "sf-pro-text-medium" }}>₹{((addon?.price * addon?.quantity) / 100).toFixed(2)}</span>
																		</div>
																	);
																})}
															</div>
														}
													</div>
												)
											)}
										</div>
									)}

									{/* {upgradeData?.length === 0 || addedItems.every(item => Array.isArray(item?.AddOnItem) && item?.AddOnItem.length > 0) ? null : ( */}
									{upgradeData?.length === 0 || upgradeData.some(item => !item?.AddOnItem || item?.AddOnItem?.length === 0) && (
										<>
											<div className="co-ra-div">
												<img
													className="ra-leftline"
													src={theme === "pvrTheme" ? leftLinePVR : leftLineINOX}
													alt="left-line"
												/>
												<p className="co-ra-ptag">UPGRADE YOUR CART</p>
												<img
													className="ra-rightline"
													src={theme === "pvrTheme" ? rightLinePVR : leftLineINOX}
													alt="right-line"
												/>
											</div>
											<div className={currentClasses.vchrLanding}>
												<div ref={scrollUpgradeRef} className="Rec-outer">
													{upgradeData
														?.filter(item => !item?.AddOnItem || item?.AddOnItem?.length === 0)
														.map((item) => {
															const parentDetails = addedItems?.find(addedItem => addedItem.ItemID === item.upgradeParentId);
															return (
																<UpgradeCart
																	key={`upgrade-${item.ItemID}`}
																	data={item}
																	parentData={parentDetails}
																	cartItemIds={cartItemIds.current}
																	removeFromCart={removeFromCart}
																	totalItems={countAllItems}
																	handleUpgradeModalShow={() => handleUpgradeModalShow(item)}
																/>
															);
														})}
												</div>

												{getWindowWidth && upgradeData.length > 2 && (
													<>
														{isRightArrowVisibleUpgrade && (
															<img
																className="rptarw fnb-arrow fnb-scrollArrRight"
																src={scrollIcon}
																alt="scrollIcon"
																onClick={() => handleUpgradeScroll("right")}
															/>
														)}
														{isLeftArrowVisibleUpgrade && (
															<img
																className="rptarw fnb-arrow fnb-scrollArrleft"
																src={scrollIcon}
																alt="scrollIcon"
																onClick={() => handleUpgradeScroll("left")}
															/>
														)}
													</>
												)}
											</div>
										</>
									)}

									{missingItems?.length > 0 && (
										<>
											<div className="co-ra-div">
												<img
													className="ra-leftline"
													src={theme === "pvrTheme" ? leftLinePVR : leftLineINOX}
													alt="left-line"
												/>
												<p className="co-ra-ptag">MISSING SOMETHING</p>
												<img
													className="ra-rightline"
													src={theme === "pvrTheme" ? rightLinePVR : leftLineINOX}
													alt="right-line"
												/>
											</div>
											<div className={currentClasses.vchrLanding}>
												<div ref={scrollRepeatAgainRef} className="Rec-outer">
													{missingItems?.map((item) => (
														<RecommendeCard
															key={`repeat-${item.id}`}
															data={item}
															handleFoodInfoShow={() => handleFoodInfoShow(item)}
															handleCustomizfoShow={false}
															addedItems={addedItems}
															cartItemIds={cartItemIds.current}
															updateAddedItems={addToCart}
															updateCount={addToCart}
															removeFromCart={removeFromCart}
															totalItems={countAllItems}
														/>
													)
													)}
												</div>

												{getWindowWidth && clu.length > 2 && (
													<>
														{isRightArrowVisibleRepeat && (
															<img
																className="rptarw fnb-arrow fnb-scrollArrRight"
																src={scrollIcon}
																alt="scrollIcon"
																onClick={() => handleScrollRepeat("right")}
															/>
														)}
														{isLeftArrowVisibleRepeat && (
															<img
																className="rptarw fnb-arrow fnb-scrollArrleft"
																src={scrollIcon}
																alt="scrollIcon"
																onClick={() => handleScrollRepeat("left")}
															/>
														)}
													</>
												)}
											</div>
										</>
									)}
									{/* <div style={{ marginTop: "10px" }} className="co-ra-div">
										<img
											className="ra-leftline"
											src={theme === "pvrTheme" ? leftLinePVR : leftLineINOX}
											alt="left-line"
										/>
										<p className="co-ra-ptag">OFFERS & VOUCHERS</p>
										<img
											className="ra-rightline"
											src={theme === "pvrTheme" ? rightLinePVR : rightLineINOX}
											alt="right-line"
										/>
									</div> */}

									{/* <div className="fb-a-offer">
										<div className={`fb-a-a `} onClick={() => fnbPaymentDetailsAPI("offers")}>
											<p className="fb-a-aLink">
												<img
													className="tra-dic-co"
													src={theme === "pvrTheme" ? traDicPVR : traDicINOX}
													alt=""
												/>
												{payDetailLoading ? "Loading..." : "Explore & Apply Offers"}
											</p>
											<img src={rightArr} alt="" />
										</div>
										{removeApplied && location && discAmt >= 0 && (
											<>
												<div className="co-dass">
													<img className="co-dassImg" src={dassadLine} alt="" />
												</div>

												<div className="co-savepop">
													<p className="co-savepopP">
														Save ₹{discAmt} with ‘{appliedVocher?.vouPayType === "PROMOCODE" ? appliedVocher?.vouId : appliedVocher?.vouDesc}’
													</p>
													<img
														src={closeIcon}
														alt=""
														onClick={handleRemoveOfferApplied}
													/>
												</div>
											</>
										)}
									</div> */}
									{/* {bookType !== "BOOKING" &&
										<> */}
									<div className="co-ra-div">
										<img
											className="ra-leftline"
											src={theme === "pvrTheme" ? leftLinePVR : leftLineINOX}
											alt="left-line"
										/>
										<p className="co-ra-ptag">ORDER DELIVERY</p>
										<img
											className="ra-rightline"
											src={theme === "pvrTheme" ? rightLinePVR : rightLineINOX}
											alt="right-line"
										/>
									</div>

									<div className="dts-main-div">
										<div className="dts-inn-div" style={{ display: "block" }}>

											{/* AISLE SERVICE OPTION */}
											{(() => {
												// Helper variables for clean, non-repetitive logic
												const isSeatUnavailable =
													!selectedTheater?.fbDeliveryOnSeat ||
													(TransactionType === "OnlyFB" && fnb_qr !== "YES") ||
													getWindowWidth;

												const isAisleActive =
													!getWindowWidth &&
													((screenType && screenType !== "NORMAL" && TransactionType === "OnlyFB" && seatdetails?.seatrow) ||
														selected === "radio1" ||
														(renderSeatInfo() && selected === null));

												const shouldShowSeatInfo =
													!getWindowWidth &&
													((screenType && screenType !== "NORMAL" && TransactionType === "OnlyFB" && (seatdetails?.seatrow || fnb_qr !== "YES")) ||
														!selectedTheater?.fbDeliveryOnSeat ||
														(TransactionType !== "OnlyFB" && showSeatInfo));

												return (
													<div
														onClick={handleClick}
														className={`dtmsDiv ${isSeatUnavailable ? "seatntaval" : isAisleActive ? "rdactive" : ""}`}
													>
														{loadingSeat ? (
															"Loading..."
														) : (
															<>
																<div className="inrDisc">
																	<p className="dtmsP">Service on Aisle</p>

																	{getWindowWidth ? (
																		<p className="confirmSeat">
																			Available on PVR INOX Mobile App
																		</p>
																	) : shouldShowSeatInfo ? (
																		<p className="confirmSeat">
																			{renderSeatInfo()}
																		</p>
																	) : (
																		<>
																			{!(screenName && selectedSeat) && (
																				<p className="confirmSeat">
																					<span className="dfltxt">
																						Introduced feature at <b>zero</b> additional cost
																					</span>
																				</p>
																			)}

																			<p className="confirmSeat">
																				{screenName}
																				{screenName && selectedSeat ? ", " : ""}
																				{selectedSeat}
																			</p>
																		</>
																	)}
																</div>
																<div className={`rdochk ${isSeatUnavailable ? "seatntaval" : isAisleActive ? "rdactive" : ""}`}>
																	{!isSeatUnavailable && isAisleActive && (
																		<img
																			src={theme === "pvrTheme" ? checkPVR : checkINOX}
																			alt="Selected"
																		/>
																	)}
																</div>
															</>
														)}
													</div>
												);
											})()}

											{/* PICKUP OPTION */}
											<div
												onClick={() => handleRadioTypeClick("radio2")}
												className={`dtmsDiv ${selected === "radio2" ? "rdactive" : ""}`}
											>
												<div className="inrDisc">
													<p className="dtmsP">Pick-up from counter</p>
													<p className="confirmSeat">
														{screenType && screenType !== "NORMAL" && TransactionType === "OnlyFB" && seatdetails?.seatrow
															? ""
															: selected === "radio2" && `${PickupBookingDate} ${PickupBookingTime}`}
													</p>
												</div>
												<div className={`rdochk ${selected === "radio2" ? "rdactive" : ""}`}>
													{selected === "radio2" && (
														<img
															src={theme === "pvrTheme" ? checkPVR : checkINOX}
															alt="Selected"
														/>
													)}
												</div>
											</div>

											{/* DYNAMIC TIME SLOTS - Shows ONSEAT when radio1, PICKUP when radio2 */}
											{selectedMovie?.deliveryModeVisible && selected && (
												<div className="select-time-delivery">
													<div className="co-ra-div">
														<p className="co-ra-ptag text-center">SELECT DELIVERY TIME</p>
													</div>

													{(() => {
														const targetMode = selected === "radio1" ? "ONSEAT" : "PICKUP";
														const filteredOptions =
															selectedMovie?.deliveryModeType
																?.find((mode) => mode.deliveryMode === targetMode)
																?.options?.sort((a, b) => a.priority - b.priority) || [];

														return filteredOptions.map((option) => {
															const isSelected = selectedOption === option.value;
															return (
																<div
																	key={option.value || option.id}
																	className={`dtmsDiv ${isSelected ? "rdactive" : ""}`}
																	onClick={() => setSelectedOption(option.value)}
																>
																	<div className="inrDisc">
																		<p className="dtmsP">{option.label}</p>
																	</div>
																	<div className={`rdochk ${isSelected ? "rdactive" : ""}`}>
																		{isSelected && (
																			<img
																				src={theme === "pvrTheme" ? checkPVR : checkINOX}
																				alt="Selected"
																			/>
																		)}
																	</div>
																</div>
															);
														});
													})()}
												</div>
											)}

										</div>
									</div>

									{/* </>
									} */}
									{appliedOffer && (
										<>
											<div style={{ marginTop: "10px" }} className="co-ra-div">
												<img
													className="ra-leftline"
													src={theme === "pvrTheme" ? leftLinePVR : leftLineINOX}
													alt="left-line"
												/>
												<p className="co-ra-ptag">OFFERS FOR YOU</p>
												<img
													className="ra-rightline"
													src={theme === "pvrTheme" ? rightLinePVR : rightLineINOX}
													alt="right-line"
												/>
											</div>
											<div className="fb-a-offer">
												<div className={`fb-a-a `}>
													{/* <div className={`fb-a-a `} onClick={() => fnbPaymentDetailsAPI("offers")}> */}
													<p className="fb-a-aLink">
														{/* <img
															className="tra-dic-co"
															src={theme === "pvrTheme" ? traDicPVR : traDicINOX}
															alt=""
														/> */}
														<img className="tra-dic-co" src={theme === "pvrTheme" ? cartIcon : cartIcon} alt="" />
														Cart Value Deals
														{/* {payDetailLoading ? "Loading..." : "Explore & Apply Offers"} */}
													</p>
													{/* <img src={rightArr} alt="" /> */}
												</div>

												{appliedOffer &&
													Number(totalGrandAmount) >= Number(appliedOffer?.minTrnValue || 0) &&
													Number(totalGrandAmount) <= Number(appliedOffer?.maxTrnValue || Number.MAX_SAFE_INTEGER) && (
														<div className={`prcwrth ${removeApplied ? "rmvofr" : "appliedOffer"}`} onClick={handleToggleOffer} style={{ backgroundColor: isChecked ? "#e6efea" : "#FFF" }}>
															<div className="aplylist">
																{removeApplied && discAmt >= 0
																	? (
																		<svg className='chckIcon' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path d="M7.23039 0.597215C8.16472 -0.199069 9.53906 -0.199077 10.4735 0.597223L11.5968 1.55451C11.7302 1.66826 11.8961 1.73698 12.071 1.75093L13.5422 1.86834C14.766 1.96599 15.7378 2.9378 15.8355 4.16156L15.9529 5.63279C15.9668 5.80758 16.0355 5.97353 16.1492 6.10701L17.1066 7.23038C17.9029 8.16471 17.9029 9.53905 17.1066 10.4735L16.1492 11.5967C16.0356 11.7302 15.9667 11.8962 15.9528 12.071L15.8355 13.5422C15.7378 14.766 14.766 15.7378 13.5422 15.8354L12.071 15.9528C11.8961 15.9668 11.7302 16.0355 11.5968 16.1493L10.4735 17.1065C9.53906 17.9029 8.16472 17.9028 7.23031 17.1065L6.10698 16.1493C5.97352 16.0355 5.8076 15.9668 5.63281 15.9529L4.16159 15.8354C2.93781 15.7377 1.96602 14.766 1.86837 13.5422L1.75094 12.071C1.73699 11.8962 1.66825 11.7303 1.55452 11.5968L0.597224 10.4734C-0.199068 9.53905 -0.199076 8.1648 0.597207 7.23038L1.55451 6.10704C1.66825 5.97357 1.73701 5.80758 1.75095 5.63278L1.86836 4.16155C1.96601 2.93778 2.93778 1.96601 4.16156 1.86835L5.6328 1.75094C5.8076 1.73699 5.97355 1.66826 6.10702 1.55451L7.23039 0.597215ZM9.39239 1.86573C9.08097 1.60031 8.62281 1.60031 8.31139 1.86573L7.18806 2.82304C6.78764 3.16426 6.28979 3.37047 5.76537 3.41232L4.29414 3.52973C3.88622 3.56229 3.56229 3.88621 3.52974 4.29414L3.41232 5.76541C3.37047 6.28981 3.16427 6.78762 2.82305 7.18805L1.86575 8.31138C1.60032 8.6228 1.60032 9.08096 1.86575 9.39238L2.82305 10.5157C3.16427 10.9161 3.37047 11.414 3.41235 11.9384L3.52975 13.4096C3.56229 13.8175 3.88622 14.1415 4.29416 14.174L5.76536 14.2915C6.28975 14.3333 6.78764 14.5395 7.18806 14.8808L8.31139 15.838C8.62289 16.1035 9.08097 16.1035 9.39239 15.838L10.5158 14.8807C10.9161 14.5395 11.414 14.3333 11.9384 14.2915L13.4096 14.174C13.8176 14.1415 14.1416 13.8175 14.1741 13.4096L14.2915 11.9384C14.3333 11.414 14.5395 10.9161 14.8808 10.5158L15.8381 9.39238C16.1036 9.08096 16.1035 8.62288 15.8381 8.31138L14.8807 7.18805C14.5395 6.78762 14.3333 6.28979 14.2915 5.76538L14.1741 4.29414C14.1416 3.88621 13.8176 3.56229 13.4096 3.52973L11.9384 3.41233C11.4141 3.37049 10.9161 3.16426 10.5157 2.82303L9.39239 1.86573ZM11.2087 5.31645L12.3872 6.49496L6.49467 12.3875L5.31617 11.209L11.2087 5.31645ZM7.37856 7.3788C6.8904 7.86696 6.09895 7.86696 5.61079 7.3788C5.12263 6.89071 5.12263 6.09923 5.61079 5.61107C6.09895 5.12291 6.8904 5.12291 7.37856 5.61107C7.86672 6.09923 7.86672 6.89071 7.37856 7.3788ZM10.3248 12.0929C10.813 12.581 11.6044 12.581 12.0926 12.0929C12.5807 11.6047 12.5807 10.8133 12.0926 10.3251C11.6044 9.83696 10.813 9.83696 10.3248 10.3251C9.83664 10.8133 9.83664 11.6047 10.3248 12.0929Z" fill="#007D23" />
																		</svg>
																		// <svg className='chckIcon' xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z" clip-rule="evenodd" /></svg>
																	) : (
																		<svg className='chckIcon' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
																			<path d="M7.23039 0.597215C8.16472 -0.199069 9.53906 -0.199077 10.4735 0.597223L11.5968 1.55451C11.7302 1.66826 11.8961 1.73698 12.071 1.75093L13.5422 1.86834C14.766 1.96599 15.7378 2.9378 15.8355 4.16156L15.9529 5.63279C15.9668 5.80758 16.0355 5.97353 16.1492 6.10701L17.1066 7.23038C17.9029 8.16471 17.9029 9.53905 17.1066 10.4735L16.1492 11.5967C16.0356 11.7302 15.9667 11.8962 15.9528 12.071L15.8355 13.5422C15.7378 14.766 14.766 15.7378 13.5422 15.8354L12.071 15.9528C11.8961 15.9668 11.7302 16.0355 11.5968 16.1493L10.4735 17.1065C9.53906 17.9029 8.16472 17.9028 7.23031 17.1065L6.10698 16.1493C5.97352 16.0355 5.8076 15.9668 5.63281 15.9529L4.16159 15.8354C2.93781 15.7377 1.96602 14.766 1.86837 13.5422L1.75094 12.071C1.73699 11.8962 1.66825 11.7303 1.55452 11.5968L0.597224 10.4734C-0.199068 9.53905 -0.199076 8.1648 0.597207 7.23038L1.55451 6.10704C1.66825 5.97357 1.73701 5.80758 1.75095 5.63278L1.86836 4.16155C1.96601 2.93778 2.93778 1.96601 4.16156 1.86835L5.6328 1.75094C5.8076 1.73699 5.97355 1.66826 6.10702 1.55451L7.23039 0.597215ZM9.39239 1.86573C9.08097 1.60031 8.62281 1.60031 8.31139 1.86573L7.18806 2.82304C6.78764 3.16426 6.28979 3.37047 5.76537 3.41232L4.29414 3.52973C3.88622 3.56229 3.56229 3.88621 3.52974 4.29414L3.41232 5.76541C3.37047 6.28981 3.16427 6.78762 2.82305 7.18805L1.86575 8.31138C1.60032 8.6228 1.60032 9.08096 1.86575 9.39238L2.82305 10.5157C3.16427 10.9161 3.37047 11.414 3.41235 11.9384L3.52975 13.4096C3.56229 13.8175 3.88622 14.1415 4.29416 14.174L5.76536 14.2915C6.28975 14.3333 6.78764 14.5395 7.18806 14.8808L8.31139 15.838C8.62289 16.1035 9.08097 16.1035 9.39239 15.838L10.5158 14.8807C10.9161 14.5395 11.414 14.3333 11.9384 14.2915L13.4096 14.174C13.8176 14.1415 14.1416 13.8175 14.1741 13.4096L14.2915 11.9384C14.3333 11.414 14.5395 10.9161 14.8808 10.5158L15.8381 9.39238C16.1036 9.08096 16.1035 8.62288 15.8381 8.31138L14.8807 7.18805C14.5395 6.78762 14.3333 6.28979 14.2915 5.76538L14.1741 4.29414C14.1416 3.88621 13.8176 3.56229 13.4096 3.52973L11.9384 3.41233C11.4141 3.37049 10.9161 3.16426 10.5157 2.82303L9.39239 1.86573ZM11.2087 5.31645L12.3872 6.49496L6.49467 12.3875L5.31617 11.209L11.2087 5.31645ZM7.37856 7.3788C6.8904 7.86696 6.09895 7.86696 5.61079 7.3788C5.12263 6.89071 5.12263 6.09923 5.61079 5.61107C6.09895 5.12291 6.8904 5.12291 7.37856 5.61107C7.86672 6.09923 7.86672 6.89071 7.37856 7.3788ZM10.3248 12.0929C10.813 12.581 11.6044 12.581 12.0926 12.0929C12.5807 11.6047 12.5807 10.8133 12.0926 10.3251C11.6044 9.83696 10.813 9.83696 10.3248 10.3251C9.83664 10.8133 9.83664 11.6047 10.3248 12.0929Z" fill="#007D23" />
																		</svg>
																	)}
																<span className="vocTitle">{appliedOffer?.vouDesc}</span>
																{/* {removeApplied && discAmt >= 0 ? (
																<span className="removeOfrbtn" onClick={handleRemoveOfferApplied}>
																	{loading ? "Processing..." : "Remove"}
																</span>
															) : (
																<span className="removeOfrbtn applyofr">
																	<label className="checkbox-wrapper">
																		<input
																			type="checkbox"
																			checked={isChecked}
																			onChange={(e) => {
																				const checked = e.target.checked;
																				setIsChecked(checked);
																			}}
																			className="hidden-checkbox"
																		/>
																		<span className="custom-check"></span>
																	</label>

																</span>
															)} */}
																<span className="removeOfrbtn applyofr">
																	<label className="checkbox-wrapper" onClick={(e) => e.stopPropagation()}>
																		<input
																			type="checkbox"
																			checked={isChecked}
																			onClick={handleToggleOffer}
																			onChange={() => { }}
																			// onChange={(e) => {
																			// 	const checked = e.target.checked;
																			// 	setIsChecked(checked);
																			// }}
																			className="hidden-checkbox"
																		/>
																		<span className="custom-check"></span>
																	</label>

																</span>
															</div>
														</div>
													)}

												{nearestOffer && (
													<div className="prcwrth appliedOffer">
														<div className="aplylist">
															<svg className='chckIcon' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path d="M7.23039 0.597215C8.16472 -0.199069 9.53906 -0.199077 10.4735 0.597223L11.5968 1.55451C11.7302 1.66826 11.8961 1.73698 12.071 1.75093L13.5422 1.86834C14.766 1.96599 15.7378 2.9378 15.8355 4.16156L15.9529 5.63279C15.9668 5.80758 16.0355 5.97353 16.1492 6.10701L17.1066 7.23038C17.9029 8.16471 17.9029 9.53905 17.1066 10.4735L16.1492 11.5967C16.0356 11.7302 15.9667 11.8962 15.9528 12.071L15.8355 13.5422C15.7378 14.766 14.766 15.7378 13.5422 15.8354L12.071 15.9528C11.8961 15.9668 11.7302 16.0355 11.5968 16.1493L10.4735 17.1065C9.53906 17.9029 8.16472 17.9028 7.23031 17.1065L6.10698 16.1493C5.97352 16.0355 5.8076 15.9668 5.63281 15.9529L4.16159 15.8354C2.93781 15.7377 1.96602 14.766 1.86837 13.5422L1.75094 12.071C1.73699 11.8962 1.66825 11.7303 1.55452 11.5968L0.597224 10.4734C-0.199068 9.53905 -0.199076 8.1648 0.597207 7.23038L1.55451 6.10704C1.66825 5.97357 1.73701 5.80758 1.75095 5.63278L1.86836 4.16155C1.96601 2.93778 2.93778 1.96601 4.16156 1.86835L5.6328 1.75094C5.8076 1.73699 5.97355 1.66826 6.10702 1.55451L7.23039 0.597215ZM9.39239 1.86573C9.08097 1.60031 8.62281 1.60031 8.31139 1.86573L7.18806 2.82304C6.78764 3.16426 6.28979 3.37047 5.76537 3.41232L4.29414 3.52973C3.88622 3.56229 3.56229 3.88621 3.52974 4.29414L3.41232 5.76541C3.37047 6.28981 3.16427 6.78762 2.82305 7.18805L1.86575 8.31138C1.60032 8.6228 1.60032 9.08096 1.86575 9.39238L2.82305 10.5157C3.16427 10.9161 3.37047 11.414 3.41235 11.9384L3.52975 13.4096C3.56229 13.8175 3.88622 14.1415 4.29416 14.174L5.76536 14.2915C6.28975 14.3333 6.78764 14.5395 7.18806 14.8808L8.31139 15.838C8.62289 16.1035 9.08097 16.1035 9.39239 15.838L10.5158 14.8807C10.9161 14.5395 11.414 14.3333 11.9384 14.2915L13.4096 14.174C13.8176 14.1415 14.1416 13.8175 14.1741 13.4096L14.2915 11.9384C14.3333 11.414 14.5395 10.9161 14.8808 10.5158L15.8381 9.39238C16.1036 9.08096 16.1035 8.62288 15.8381 8.31138L14.8807 7.18805C14.5395 6.78762 14.3333 6.28979 14.2915 5.76538L14.1741 4.29414C14.1416 3.88621 13.8176 3.56229 13.4096 3.52973L11.9384 3.41233C11.4141 3.37049 10.9161 3.16426 10.5157 2.82303L9.39239 1.86573ZM11.2087 5.31645L12.3872 6.49496L6.49467 12.3875L5.31617 11.209L11.2087 5.31645ZM7.37856 7.3788C6.8904 7.86696 6.09895 7.86696 5.61079 7.3788C5.12263 6.89071 5.12263 6.09923 5.61079 5.61107C6.09895 5.12291 6.8904 5.12291 7.37856 5.61107C7.86672 6.09923 7.86672 6.89071 7.37856 7.3788ZM10.3248 12.0929C10.813 12.581 11.6044 12.581 12.0926 12.0929C12.5807 11.6047 12.5807 10.8133 12.0926 10.3251C11.6044 9.83696 10.813 9.83696 10.3248 10.3251C9.83664 10.8133 9.83664 11.6047 10.3248 12.0929Z" fill="#007D23" />
															</svg>
															<span className="vocTitle" style={{ opacity: 0.5 }}>
																{nearestOffer?.vouDesc}
															</span>
															<span className="offer-check-inactive"></span>
														</div>
														<div className="ofrinfo">
															<svg className='chckIcon infoIcon' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.3 7.29c.2-.18.44-.29.7-.29c.27 0 .5.11.71.29c.19.21.29.45.29.71c0 .27-.1.5-.29.71c-.21.19-.44.29-.71.29c-.26 0-.5-.1-.7-.29c-.19-.21-.3-.44-.3-.71c0-.26.11-.5.3-.71m-2.5 4.68s2.17-1.72 2.96-1.79c.74-.06.59.79.52 1.23l-.01.06c-.14.53-.31 1.17-.48 1.78c-.38 1.39-.75 2.75-.66 3c.1.34.72-.09 1.17-.39c.06-.04.11-.08.16-.11c0 0 .08-.08.16.03c.02.03.04.06.06.08c.09.14.14.19.02.27l-.04.02c-.22.15-1.16.81-1.54 1.05c-.41.27-1.98 1.17-1.74-.58c.21-1.23.49-2.29.71-3.12c.41-1.5.59-2.18-.33-1.59c-.37.22-.59.36-.72.45c-.11.08-.12.08-.19-.05l-.03-.06l-.05-.08c-.07-.1-.07-.11.03-.2M22 12c0 5.5-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2s10 4.5 10 10m-2 0c0-4.42-3.58-8-8-8s-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8" /></svg>
															<span className="vocTitle">
																Add items worth {nearestOffer?.minTrnValue - totalGrandAmount} more to unlock this offer!
															</span>
														</div>
													</div>
												)}

												{/* <div className='prcwrth'>
											<div className='aplylist'>
												<svg className='chckIcon' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z" clip-rule="evenodd" /></svg>
												<span className='vocTitle'>Flat 100 OFF on order above 500</span>
												<span className='removeOfrbtn'>Remove</span>
											</div>
										</div>
										<div className='prcwrth'>
											<div className='aplylist'>
												<svg className='chckIcon' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path d="M7.23039 0.597215C8.16472 -0.199069 9.53906 -0.199077 10.4735 0.597223L11.5968 1.55451C11.7302 1.66826 11.8961 1.73698 12.071 1.75093L13.5422 1.86834C14.766 1.96599 15.7378 2.9378 15.8355 4.16156L15.9529 5.63279C15.9668 5.80758 16.0355 5.97353 16.1492 6.10701L17.1066 7.23038C17.9029 8.16471 17.9029 9.53905 17.1066 10.4735L16.1492 11.5967C16.0356 11.7302 15.9667 11.8962 15.9528 12.071L15.8355 13.5422C15.7378 14.766 14.766 15.7378 13.5422 15.8354L12.071 15.9528C11.8961 15.9668 11.7302 16.0355 11.5968 16.1493L10.4735 17.1065C9.53906 17.9029 8.16472 17.9028 7.23031 17.1065L6.10698 16.1493C5.97352 16.0355 5.8076 15.9668 5.63281 15.9529L4.16159 15.8354C2.93781 15.7377 1.96602 14.766 1.86837 13.5422L1.75094 12.071C1.73699 11.8962 1.66825 11.7303 1.55452 11.5968L0.597224 10.4734C-0.199068 9.53905 -0.199076 8.1648 0.597207 7.23038L1.55451 6.10704C1.66825 5.97357 1.73701 5.80758 1.75095 5.63278L1.86836 4.16155C1.96601 2.93778 2.93778 1.96601 4.16156 1.86835L5.6328 1.75094C5.8076 1.73699 5.97355 1.66826 6.10702 1.55451L7.23039 0.597215ZM9.39239 1.86573C9.08097 1.60031 8.62281 1.60031 8.31139 1.86573L7.18806 2.82304C6.78764 3.16426 6.28979 3.37047 5.76537 3.41232L4.29414 3.52973C3.88622 3.56229 3.56229 3.88621 3.52974 4.29414L3.41232 5.76541C3.37047 6.28981 3.16427 6.78762 2.82305 7.18805L1.86575 8.31138C1.60032 8.6228 1.60032 9.08096 1.86575 9.39238L2.82305 10.5157C3.16427 10.9161 3.37047 11.414 3.41235 11.9384L3.52975 13.4096C3.56229 13.8175 3.88622 14.1415 4.29416 14.174L5.76536 14.2915C6.28975 14.3333 6.78764 14.5395 7.18806 14.8808L8.31139 15.838C8.62289 16.1035 9.08097 16.1035 9.39239 15.838L10.5158 14.8807C10.9161 14.5395 11.414 14.3333 11.9384 14.2915L13.4096 14.174C13.8176 14.1415 14.1416 13.8175 14.1741 13.4096L14.2915 11.9384C14.3333 11.414 14.5395 10.9161 14.8808 10.5158L15.8381 9.39238C16.1036 9.08096 16.1035 8.62288 15.8381 8.31138L14.8807 7.18805C14.5395 6.78762 14.3333 6.28979 14.2915 5.76538L14.1741 4.29414C14.1416 3.88621 13.8176 3.56229 13.4096 3.52973L11.9384 3.41233C11.4141 3.37049 10.9161 3.16426 10.5157 2.82303L9.39239 1.86573ZM11.2087 5.31645L12.3872 6.49496L6.49467 12.3875L5.31617 11.209L11.2087 5.31645ZM7.37856 7.3788C6.8904 7.86696 6.09895 7.86696 5.61079 7.3788C5.12263 6.89071 5.12263 6.09923 5.61079 5.61107C6.09895 5.12291 6.8904 5.12291 7.37856 5.61107C7.86672 6.09923 7.86672 6.89071 7.37856 7.3788ZM10.3248 12.0929C10.813 12.581 11.6044 12.581 12.0926 12.0929C12.5807 11.6047 12.5807 10.8133 12.0926 10.3251C11.6044 9.83696 10.813 9.83696 10.3248 10.3251C9.83664 10.8133 9.83664 11.6047 10.3248 12.0929Z" fill="#007D23" />
												</svg>
												<span className='vocTitle'>Flat 100 OFF on order above 500</span>
												<span className='removeOfrbtn applyofr'>Apply</span>
											</div>
											<div className='ofrinfo'>
												<svg className='chckIcon infoIcon' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.3 7.29c.2-.18.44-.29.7-.29c.27 0 .5.11.71.29c.19.21.29.45.29.71c0 .27-.1.5-.29.71c-.21.19-.44.29-.71.29c-.26 0-.5-.1-.7-.29c-.19-.21-.3-.44-.3-.71c0-.26.11-.5.3-.71m-2.5 4.68s2.17-1.72 2.96-1.79c.74-.06.59.79.52 1.23l-.01.06c-.14.53-.31 1.17-.48 1.78c-.38 1.39-.75 2.75-.66 3c.1.34.72-.09 1.17-.39c.06-.04.11-.08.16-.11c0 0 .08-.08.16.03c.02.03.04.06.06.08c.09.14.14.19.02.27l-.04.02c-.22.15-1.16.81-1.54 1.05c-.41.27-1.98 1.17-1.74-.58c.21-1.23.49-2.29.71-3.12c.41-1.5.59-2.18-.33-1.59c-.37.22-.59.36-.72.45c-.11.08-.12.08-.19-.05l-.03-.06l-.05-.08c-.07-.1-.07-.11.03-.2M22 12c0 5.5-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2s10 4.5 10 10m-2 0c0-4.42-3.58-8-8-8s-8 3.58-8 8s3.58 8 8 8s8-3.58 8-8" /></svg>
												<span className='vocTitle'>Add items worth 430 more ti unlock this offers!</span>
											</div>
										</div> */}

												{/* {removeApplied && location && discAmt >= 0 && (
											<>
												<div className="co-dass">
													<img className="co-dassImg" src={dassadLine} alt="" />
												</div>

												<div className="co-savepop">
													<p className="co-savepopP">
														Save ₹{discAmt} with ‘{appliedVocher?.vouPayType === "PROMOCODE" ? appliedVocher?.vouId : appliedVocher?.vouDesc}’
													</p>
													<img
														src={closeIcon}
														alt=""
														onClick={handleRemoveOfferApplied}
													/>
												</div>
											</>
										)} */}
											</div>
										</>
									)}
									<div className="co-ra-div">
										<img
											className="ra-leftline"
											src={theme === "pvrTheme" ? leftLinePVR : leftLineINOX}
											alt="left-line"
										/>
										<p className="co-ra-ptag">BILL DETAILS</p>
										<img
											className="ra-rightline"
											src={theme === "pvrTheme" ? rightLinePVR : rightLineINOX}
											alt="right-line"
										/>
									</div>
									<div className="fb-stdiv">
										<div className="fb-stdivInn">
											{isChecked && appliedOffer?.discValue >= 0 && (
												<>
													<div className="fb-stdivI">
														<p className="fb-stp chksb">Sub Total</p>
														<p className="fb-stp prcfont chksb">

															{addedItems
																? `₹${(addedItems.reduce((total, item) => {
																	const totalPrice = item?.price * item.quantity;
																	const addonPrice = item?.AddOnItem?.reduce((addonTotal, addon) => {
																		return addonTotal + (addon?.price * addon.quantity || 0);
																	}, 0);

																	return total + totalPrice + addonPrice
																}, 0) / 100).toFixed(2)}`
																: "-"}
														</p>
													</div>
													{/* <img src={dassadLine} alt="" /> */}
													<div className="fb-stdiv4 b1 chkofr">
														<p className="fb-stpII">Offer Applied</p>
														<p className="fb-stpII2">
															-₹
															{(() => {
																let discount = 0;

																if (appliedOffer?.discOn?.toLowerCase() === "per") {
																	discount =
																		(Number(totalGrandAmount || 0) *
																			Number(appliedOffer?.discValue || 0)) /
																		100;
																} else {
																	discount = Number(appliedOffer?.discValue || 0);
																}

																if (
																	appliedOffer?.maxDiscAmt &&
																	discount > Number(appliedOffer?.maxDiscAmt)
																) {
																	discount = Number(appliedOffer?.maxDiscAmt);
																}

																return discount.toFixed(2);
															})()}
														</p>
													</div>
													{/* <img src={dassadLine} alt="" /> */}
												</>
											)}

											<div className="fb-stdivIIIII">
												<p className="fb-stpIII">Food Total</p>
												<p className="fb-stpIII prcfont">
													₹
													{(() => {
														if (!isChecked || !appliedOffer) return totalGrandAmount;

														let discount = 0;

														if (appliedOffer.discOn?.toLowerCase() === "per") {
															// Calculate percentage discount
															discount = (totalGrandAmount * appliedOffer.discValue) / 100;
															if (appliedOffer.maxDiscAmt && discount > appliedOffer.maxDiscAmt) {
																discount = appliedOffer.maxDiscAmt;
															}
														} else {
															// Flat discount
															discount = appliedOffer.discValue;
															if (appliedOffer.maxDiscAmt && discount > appliedOffer.maxDiscAmt) {
																discount = appliedOffer.maxDiscAmt;
															}
														}

														return (totalGrandAmount - discount).toFixed(2);
													})()}
												</p>
											</div>
											<p className="fb-stp" style={{ marginBottom: 0 }}>*Inclusive of all the taxes</p>

										</div>
									</div>
								</div>
								{/* <MobilePayment  /> */}
								<div
									onClick={() => paymentHandle(isChecked ? appliedOffer : '')}
									className={currentClasses.fbAddedDiv}
								>
									<button className="fb-added-btn">
										{paymentLoading || payDetailLoading ? (
											<span className="loading-spinner">Processing...</span>
										) : (
											isChecked
												? "Apply Voucher & Proceed"
												: getWindowWidth
													? "Proceed to Payment"
													: "Proceed"

											// removeApplied &&
											// 	finalAmount !== null &&
											// 	finalAmount !== undefined &&
											// 	!isNaN(finalAmount)
											// 	? finalAmount > 0
											// 		? (
											// 			<>
											// 				Proceed <span className='prcfont'>₹{finalAmount?.toFixed(2)}</span>
											// 			</>
											// 		)
											// 		: "Proceed to Payment"
											// 	: addedItems
											// 		? (
											// 			<>
											// 				Proceed <span className='prcfont'>₹{(addedItems.reduce((total, item) => {
											// 					const totalPrice = item?.price * item.quantity || 0;
											// 					const addonPrice = item?.AddOnItem?.reduce((addonTotal, addon) => {
											// 						return addonTotal + (addon?.price * addon.quantity || 0);
											// 					}, 0);
											// 					return total + totalPrice + addonPrice;
											// 				}, 0) / 100).toFixed(2)}</span>
											// 			</>
											// 		)
											// 		: "-"

										)}

									</button>
								</div>

							</>
						)}

					</div>
				</div>
				{bookType === "BOOKING" &&
					<div className="show-in-desktop-view col-md-3 book-summary checkfnbtkt">
						{loading ? (
							<BookingSummarySkeleton />
						) : (
							<div className="all-summary get-food-info">
								<div>
									{localStorage.getItem("booking_type") === "BOOKING" && (
										<ExtendTime />
									)}
								</div>
								<div className="booking-summary">
									<div className="book-head">
										<h3>Booking Summary</h3>
									</div>
									<div className="ticket-cancel">
									</div>
								</div>
								{localStorage.getItem("booking_type") === "BOOKING" && (
									<>
										<div className="movies-summary">
											<div className="summary-movies-photo">
												<img
													src={
														selectedMovie?.orderFilmCinema?.posterVert
															? selectedMovie?.orderFilmCinema?.posterVert
															: theme === "inoxTheme"
																? miv_inox
																: miv_pvr
													}
													alt=""
													className="img-fluid"
													width={50}
												/>
											</div>
											<div className="summary-movies-content">
												<h5>{selectedMovie?.orderFilmCinema?.filmName}</h5>
												<ul>
													<li>
														{selectedMovie?.orderFilmCinema?.certificate}
													</li>
													<li>
														<span className="dot-c"></span>
														{selectedMovie?.orderFilmCinema?.genre}
													</li>
													<li>
														<span className="dot-c"></span>
														{selectedMovie?.orderFilmCinema?.language}
													</li>
												</ul>
												<p>
													<span className=""></span>
													{selectedMovie?.orderFilmCinema?.theaterName}
												</p>
												<p>{selectedMovie?.showTime}</p>
											</div>
										</div>
										<div className="seat-info">
											<h6>Seat Info</h6>
											{localStorage.getItem("booking_type") === "BOOKING" ? (
												<div className="ticket-value">
													{selectedMovie?.orderTicket?.numOfSeats && (
														<p>{selectedMovie?.orderTicket?.showClassName}</p>
													)}
												</div>
											) : (
												""
											)}

											<div className="select-seat-number">
												{selectedMovie?.orderTicket?.seats
													?.split(",")
													.map((item, idx) => {
														return (
															<>
																<div
																	className="seat-number"
																	style={
																		theme === "inoxTheme"
																			? { backgroundColor: "#DCE2EF" }
																			: { backgroundColor: "#FFF0D6" }
																	}
																	key={idx}
																>
																	<p>{item}</p>
																</div>
															</>
														);
													})}
											</div>
										</div>
									</>
								)}

								<div className="ticket-prices">
									{localStorage.getItem("booking_type") === "BOOKING" ? (
										<>
											<h6>Tickets</h6>

											<div className="ticket-value-ticket">
												{selectedMovie?.orderTicket?.numOfSeats && (
													<div className="tickets-count">
														<h6>
															Net Price ({selectedMovie?.orderTicket?.numOfSeats}{" "}
															<b>x</b>{" "}Ticket(s))
															{/* {selectedMovie?.orderTicket?.ticketPrice} */}
														</h6>
													</div>
												)}
												<div className="ticket-price">
													<p>
														<FaRupeeSign
															style={{
																fontSize: "10px",
																fontWeight: "500",
																marginBottom: "2px",
															}}
														/>
														{selectedMovie?.orderTicket?.totalNetTicketPrice?.replace(
															/,/g,
															""
														)}
													</p>
												</div>
											</div>

											<div className="ticket-value-ticket">
												{selectedMovie?.orderTicket?.numOfSeats && (
													<div className="tickets-count">
														<h6>
															GST
														</h6>
													</div>
												)}
												<div className="ticket-price">
													<p>
														<FaRupeeSign
															style={{
																fontSize: "10px",
																fontWeight: "500",
																marginBottom: "2px",
															}}
														/>
														{selectedMovie?.orderTicket?.totalTicketGst?.replace(
															/,/g,
															""
														)}
													</p>
												</div>
											</div>

											<div className="ticket-value-ticket">
												{selectedMovie?.orderTicket?.numOfSeats && (
													<div className="tickets-count">
														<h6>
															Total Ticket Price
														</h6>
													</div>
												)}
												<div className="ticket-price">
													<p>
														<FaRupeeSign
															style={{
																fontSize: "10px",
																fontWeight: "500",
																marginBottom: "2px",
															}}
														/>
														{selectedMovie?.orderTicket?.totalTicketPrice?.replace(
															/,/g,
															""
														)}
													</p>
												</div>
											</div>
										</>
									) : (
										""
									)}
									{addedItems?.length === 0 ? (
										<div className="no-snack">
											<img src={noSack} alt="" className="img-fluid" />
											<p>No snacks added</p>
										</div>
									) : (
										<div className="food-beverages">
											<h6>Food & BEVERAGES</h6>
											{addedItems && selectedFoodData(addedItems)}
										</div>
									)}
								</div>

								<div className="food-pay-amount payment-details-food">
									<div className="bill-details">
										<h6>PAYMENT DETAILS</h6>
										<div className="grand-price">
											<div className="bill-amount">
												<div className="sub-total">
													<h6>Sub Total</h6>
												</div>
												<div className="tax-fees">
													<h6>
														<FaRupeeSign
															style={{
																fontSize: "10px",
																fontWeight: "500",
																marginBottom: "2px",
															}}
														/>
														{calculateMovieSubTotal(
															localStorage.getItem("booking_type"),
															selectedMovie?.orderTicket?.totalTicketPrice?.replace(/,/g, ""),
															addedItems
														)}
													</h6>
												</div>
											</div>
											{localStorage.getItem("booking_type") === "BOOKING" && (
												<>
													{selectedMovie?.orderTicket?.convTotal > 0 ? (
														<div className="bill-amounts">
															<div className="sub-total">
																<h6>
																	Taxes & Fees
																	<span
																		style={{ cursor: "pointer" }}
																		onClick={() => {
																			setShowConvFee(!showConvFee);
																		}}
																	>
																		<img
																			src={priceArrow}
																			alt=""
																			className="img-fluid"
																		/>
																	</span>
																</h6>
															</div>
															<div className="tax-fees">
																<h6>
																	<FaRupeeSign
																		style={{
																			fontSize: "10px",
																			fontWeight: "500",
																			marginBottom: "2px",
																		}}
																	/>
																	{selectedMovie?.orderTicket?.convTotal}
																</h6>
															</div>
														</div>
													) : (
														""
													)}

													{showConvFee && (
														<>
															<div className="food-show-gst">
																<div className="bill-amounts">
																	<div className="gst">
																		<h6>Convenience Fee</h6>
																	</div>
																	<div className="tax-gst">
																		<h6>
																			<FaRupeeSign
																				style={{
																					fontSize: "10px",
																					fontWeight: "500",
																					marginBottom: "2px",
																				}}
																			/>
																			{selectedMovie?.orderTicket?.conv}
																		</h6>
																	</div>
																</div>

																{selectedMovie?.orderFilmCinema
																	?.hsnSacCode ? (
																	<div className="bill-amounts">
																		<div className="gst">
																			<h6>
																				(Sac Code :{" "}
																				{
																					selectedMovie?.orderFilmCinema
																						?.hsnSacCode
																				}
																				)
																			</h6>
																		</div>
																	</div>
																) : (
																	""
																)}

																<div className="bill-amounts">
																	<div className="gst">
																		<h6>GST</h6>
																	</div>
																	<div className="tax-gst">
																		<h6>
																			<FaRupeeSign
																				style={{
																					fontSize: "10px",
																					fontWeight: "500",
																					marginBottom: "2px",
																				}}
																			/>
																			{selectedMovie?.orderTicket?.convGst}
																		</h6>
																	</div>
																</div>

																{selectedMovie?.orderFilmCinema?.stateGSTN ? (
																	<div className="bill-amounts">
																		<div className="gst">
																			<h6>GST NUMBER</h6>
																		</div>
																		<div className="tax-gst">
																			<h6>
																				{
																					selectedMovie?.orderFilmCinema
																						?.stateGSTN
																				}
																			</h6>
																		</div>
																	</div>
																) : (
																	""
																)}
															</div>
														</>
													)}
												</>
											)}
										</div>
									</div>
								</div>

								<div className="food-pay-amount grnFNBtickrt">
									<div className="seat-bottom-btn">
										<div className="all-grand">
											<div className="grand-tota col-md-3">
												<h6>Grand Total</h6>
												<h6>
													<FaRupeeSign
														style={{
															fontSize: "10px",
															fontWeight: "500",
															marginBottom: "2px",
														}}
													/>
													{calculateGrandTotal(
														localStorage.getItem("booking_type"),
														selectedMovie?.orderTicket?.totalTicketPrice?.replace(/,/g, ""),
														selectedMovie?.orderTicket?.convTotal,
														addedItems
													)}
												</h6>
											</div>
											{/* <div className="register-btn col-md-3">
											<ProceedBtn
												className="btn-proceeded"
												onClick={() => {
												IscustomEvent("Procced to Payment")
												if (addedItems.length > 0) {
													hitGa("fnb_add_checkout");
													saveFoodselectedMovie();
												} else {
													hitGa("fnb_skip");
													navigate(`/payment/${cinemaname}`);
												}
												}}
												disabled={saveFoodLoading}
											>
												{saveFoodLoading ? (
												<span>
													Proceeding
													<img src={Loader} alt="" className="img-fluid" />
												</span>
												) : (
												"Proceed"
												)}
											</ProceedBtn>
											</div> */}
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
				}
			</div>
			{getWindowWidth &&
				<Footer />
			}
			<Modal
				className={`${currentClasses.centerModal} p0`}
				show={showYourSeatModal}
				onHide={handleYourSeatModalClose}
				animation={false}
				keyboard={false}
				style={{ backgroundColor: "rgba(0,0,0,0.7)", overflow: "hidden" }}
			>
				<div className="ys-m-main-div">
					<div className="m-cus-head" style={{ justifyContent: "end" }}>
						<img
							onClick={handleYourSeatModalClose}
							src={closeIcon}
							alt="close"
						/>
					</div>
					<div className="ys-m-inn">
						<img
							className="ys-seatImg"
							src={theme === "pvrTheme" ? Seat : SeatInox}
							width={80}
							height={80}
							alt="Seat"
						/>
						<p className="ys-ptag">Your Seats</p>
						<p className="ys-pdesc">
							Your mobile no. {userInfoData?.data?.mob} returned the
							following booking(s). Please confirm by{" "}
							<b>tapping on seats below</b> to deliver your food
						</p>
					</div>
					<div className="ys-main-sinfo">
						<Swiper
							spaceBetween={
								seatDetailData?.length > 0
									? 5
									: 0
							}
							slidesPerView={
								seatDetailData?.length > 1
									? getWindowWidth
										? 1
										: 1.1
									: 1.1
							}
							centeredSlides={true}
							loop={false}
						>
							{seatDetailData
								?.filter(item => item?.theaterId === theatreId)
								.map((item, index, filteredArray) => {
									const seatsArray = item?.seats?.split(",") || [];
									return (
										<SwiperSlide className="ys-sinfo" key={index}>
											<p className="tagCount">{`${index + 1}/${filteredArray.length}`}</p>
											<h2 className="ys-moviename">{item?.filmName}</h2>
											<p className="ys-cineAdd">{item?.theaterName}</p>
											<p className="ys-cineTime">Today, {formattedShowTime} - {formattedEndTime}</p>

											<div className="ys-sbox">
												<p className="ys-seatname">{item?.audi}</p>

												<div className="ys-seatSquMain">
													<div className="ys-seatSqu">
														{seatsArray.slice(0, 5).map((seat) => (
															<p
																key={seat}
																className={`ys-seatcode ${selectedSeat === seat ? "selected" : ""}`}
																onClick={() => {
																	handleSeatClick(seat);
																	setScreenName(item?.audi);
																}}
															>
																{seat}
															</p>
														))}
													</div>
													<div className="ys-seatSqu">
														{seatsArray.slice(5, 10).map((seat) => (
															<p
																key={seat}
																className={`ys-seatcode ${selectedSeat === seat ? "selected" : ""}`}
																onClick={() => {
																	handleSeatClick(seat);
																	setScreenName(item?.audi);
																}}
															>
																{seat}
															</p>
														))}
													</div>
												</div>
												{errMsg && <div className="errmsg">Select any one seat</div>}
												<p className="ys-bdesc">Please tap on the seat to select</p>
											</div>
										</SwiperSlide>
									);
								})}
						</Swiper>
					</div>
					<p className="ys-pdesc px-3 mt-3 mb-0"><b>Note:</b> Service on Aisle will not be eligible, if your show ends within {selectedMovie?.hideShowBeforeEndTimeinMin} minutes or less</p>
					<Link to="/fnb-seats-selection" className="snf-manualBtn" style={{ margin: "5px 0 25px" }}>
						Enter Manually
					</Link>
					<button
						onClick={() => handleConfirm(seatDetailData)}
						className="ys-con-btn"
					>
						Confirm
					</button>
				</div>
			</Modal>

			<Modal
				className={`${currentClasses.centerModal} p0`}
				show={showYourSeatManual}
				onHide={handleYourSeatManualClose}
				animation={false}
				keyboard={false}
				style={{ backgroundColor: "rgba(0,0,0,0.7)", overflow: "hidden" }}
			>
				<div className="ys-m-main-div">
					<div className="m-cus-head" style={{ justifyContent: "end" }}>
						<img
							onClick={handleYourSeatManualClose}
							src={closeIcon}
							alt="close"
						/>
					</div>
					<div className="ys-m-inn">
						<img
							className="ys-seatImg"
							src={theme === "pvrTheme" ? Seat : SeatInox}
							width={80}
							height={80}
							alt="Seat"
						/>
						<p className="ys-ptag">Your Seats</p>
						<p className="ys-pdesc">
							Your mobile no. {userInfoData?.data?.mob} returned the
							following booking(s). Please confirm by{" "}
							<b>tapping on seats below</b> to deliver your food
						</p>
					</div>
					<div className="m-snf-div">
						<img src={seactNotFound} alt="" />
						<p className="snf-oops">Oops! No Movie Found..</p>
						<p className="snf-desc">
							We couldn’t find any booking against this number. Please add your
							seats manually.{" "}
						</p>
					</div>
					<p className="ys-pdesc px-3 mt-3 mb-0"><b>Note:</b> Service on Aisle will not be eligible, if your show ends within {selectedMovie?.hideShowBeforeEndTimeinMin} minutes or less</p>
					<Link to="/fnb-seats-selection" className="snf-manualBtn">
						Enter Manually
					</Link>
				</div>
			</Modal>


			<Modal
				className={`${currentClasses.centerModal} p0`}
				show={showUpgradeModal}
				onHide={handleUpgradeModalClose}
				animation={false}
				keyboard={false}
				style={{ backgroundColor: "rgba(0,0,0,0.7)", overflow: "hidden" }}
			>
				<div className="ys-m-main-div upgradeModale">
					<div className="m-cus-head" style={{ justifyContent: "end" }}>
						<img
							onClick={handleUpgradeModalClose}
							src={closeIcon}
							alt="close"
						/>
					</div>
					<div className="ys-m-inn">
						<p className="ys-ptag">Upgrade Cart Item</p>
						<div className="up-card-inn">
							<div className="Reco-item-view">
								<img className="Reco-item-viewImg"
									src={
										selectedItem?.itemImageURL
											? selectedItem?.itemImageURL
											: selectedItem?.imgData
												? `data:image/jpeg;base64,${selectedItem?.imgData}`
												: noImg
									}
									width="84" alt={selectedItem?.itemName || 'No image available'} onError={handleImageError} />
								{selectedItem?.foodType === 1 ? (
									<img className="Reco-itemVorN" src={vegIcon} alt="veg" />
								) : selectedItem?.foodType === 0 ? (
									<img className="Reco-itemNon" src={nonvegIcon} alt="veg-nonveg" />
								) : ""}
							</div>
							<div className="Reco-item-desc">
								<p className="Reco-itemName">{selectedItem?.ItemName}</p>

								<p className="Reco-itemPrice">
									₹{(selectedItem?.price) / 100}
									{/* {setSelectedItem?.AddOnItem?.length > 0 &&
										<>
											<img src={ellipse} alt="dot" />
											<span>Customizable</span>
										</>
									} */}
								</p>
							</div>
						</div>
						{upgradeItem?.quantity > 0 && (
							<>
								<h4 className="mintitle">Upgrading Options</h4>
								<div className="foodqnty">
									{Array.from({ length: upgradeItem.quantity }).map((_, index) => (
										<div
											key={`upgradeModal-${index}`}
											className={`dtmsDiv ${activeIndex === index ? "rdactive" : ""}`}
											onClick={() => handleUpgradeRadioClick(index)}
										>
											<div className="inrDisc">
												<p className="dtmsP" style={{ textTransform: 'capitalize' }}>
													{index + 1} X {upgradeItem?.ItemName || "Item Name"}
												</p>
											</div>
											<div className={`rdochk ${activeIndex === index ? "rdactive" : ""}`}>
												{activeIndex === index && (
													<img
														src={theme === "pvrTheme" ? checkPVR : checkINOX}
														alt="Selected"
													/>
												)}
											</div>
										</div>
									))}
								</div>
							</>
						)}
						<div className="flxcnf">
							<button className='cmnbtn upgradebtnNo' onClick={handleUpgradeModalClose}>No</button>
							<button className="cmnbtn upgradebtnYes" onClick={handleUpgradeConfirm}>Yes, Proceed</button>
						</div>
					</div>
				</div>
			</Modal>

			<Modal
				className={`centerModal p0`}
				show={showOffer}
				onHide={() => setShowOffer(false)}
				animation={false}
				keyboard={false}
				style={{ backgroundColor: "rgba(0,0,0,0.7)", overflow: "hidden" }}
			>
				<div className='ofrhw'>
					<img className="ifrimg" src={theme === "pvrTheme" ? offerSuccess : offerSuccessInox} alt="" />
					<h4 className='ofpc'>₹{appliedVocher?.resOffer?.output?.di} Saved</h4>
					<p className='oftitle'>{appliedVocher?.vouDesc}</p>
					<button onClick={handleOfferClose} className="frBtn"> Got it </button>
				</div>
				{/* <div className="fb-o-m">
					<img className="fb-o-emoji" src={emoji} alt="" />
					<p className="fb-m-code">'{appliedVocher?.vouDesc}' Applied!</p>
					<div className="fb-m-det">
						<p className="fb-m-price">₹{appliedVocher?.resOffer?.output?.di}</p>
						<p className="fb-m-saved">saved with this</p>
						<p className="fb-m-offP">Food Offer</p>
					</div>
					<button onClick={handleOfferClose} className="fb-m-aBtn"> Awesome! </button>
				</div> */}
			</Modal>

			<SweetAlertUtility type={alertDetails.type} title={alertDetails.title} message={alertDetails.message} show={alertDetails.show} onConfirm={hideAlert} />

			{
				showAlert && <div>
					<SweetAlert
						error
						show={showAlert}
						title={errorMsg?.result === "dialog" ? "Oops" : errorMsg?.result}
						onConfirm={() => {
							setShowAlert(false);
							if (isBadTransaction) {
								navigate("/");
							} else {
								if (isMobile) {
									navigate(`/m.payment/${localStorage.getItem("cinema_name")}`);
								} else {
									navigate(`/payment/${localStorage.getItem("cinema_name")}`);
								}
							}
						}}
						onCancel={() => setShowAlert(false)}
						showConfirm={true}
						showCancel={false}
						confirmBtnText="OK"
						confirmBtnCssClass={
							theme === "inoxTheme"
								? "confirm-btn-inox border-0"
								: "confirm-btn-pvr border-0"
						}
						closeOnClickOutside={false}
						closeOnEscape={false}
					>
						{errorMsg?.msg}
					</SweetAlert>
				</div>
			}

			<div>
				<Dialog
					header=""
					visible={loginVewMode}
					// modal={false}
					showHeader={false}
					showCloseIcon={false}
					style={{ width: "40vw" }}
					onHide={() => dispatch(setLoginViewMode({ value: false }))}
					className="register-mobile"
					blockScroll={true}
				>
					<div className="row">
						<Login />
					</div>
				</Dialog>
			</div>

		</>
	);
};

export default Checkout